import { Formik } from "formik";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  Accordion,
  Button,
  Col,
  Form,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import * as apicall from "../../components/Apicall";
import { toast } from "react-toastify";
import FieldHelpTooltip from "../../components/Help/FieldHelpTooltip";
import { HELP_CONTENT } from "../../components/Help/HelpContent";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import { FaEnvelope, FaGlobe, FaMapMarkerAlt, FaPhoneAlt, FaRegCalendarAlt } from "react-icons/fa";
import { Dropdown } from "primereact/dropdown";
import UserContext from "../../components/context/UserContext";
import BookingCalendar from "../Dashboard/BookingCalendar";
import OtpInput from "react-otp-input";
import Loader from "../../components/Loader/Loader";
import {google_places_key} from '../../constants/Constants';
import { Autocomplete, LoadScript ,useJsApiLoader } from "@react-google-maps/api";
import { validMobileNumberTest } from "../../utils/phoneValidation";
import { parseBookingRef } from "../../utils/bookingRef";
import PublicBookingShell from "./CustomerBookingFlow/PublicBookingShell";
import PublicSuccess from "./CustomerBookingFlow/PublicSuccess";
import PublicOtpPanel from "./CustomerBookingFlow/PublicOtpPanel";
import { wantsLegacyPublicForm } from "./CustomerBookingFlow/legacy";


function CustomerBookings() {
  let service = JSON.parse(localStorage.getItem("services"));
  let vendor_id = JSON.parse(localStorage.getItem("userId"));
console.log(vendor_id,"vendor_id")
  // const [searchParams] = useSearchParams();
  // let group_id = searchParams.get("group_id");
  let { group_id: groupIdParam, id } = useParams();
  let group_id = parseBookingRef(groupIdParam).groupId || undefined;

  const [services, setServices] = useState(service);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
const vendorProfile = JSON.parse(localStorage.getItem("vendorProfile")) || {};

const taxPercentage = parseFloat(vendorProfile?.tax || 0);

  // Vendor details are fetched fresh via ezpMyProfile (same pattern used by
  // Sidebar.jsx/Bookings.jsx/DashboardDetailed.jsx) rather than read from
  // localStorage.userDetails, which goes stale/gets clobbered by other tabs'
  // own vendor-profile fetches writing the same key.
  const [vendorDetails, setVendorDetails] = useState(null);

  const isCarService = Number(vendorDetails?.industry) === 8;
  const isClinicService = Number(vendorDetails?.industry) === 1;
  const isSportsService = Number(vendorDetails?.industry) === 7;
  console.log(isClinicService,"isClinicService")
  const serviceCategoryLabel = isClinicService ? "Specialization" : isSportsService ? "Sport" : "Service Category";
  const serviceTypeLabel = isClinicService ? "Specialization Type" : isSportsService ? "Sports Type" : "Service Type";
  const [initialValues, setInitialValues] = useState({
    partner: 1,
    org_id: "",
    userName: "",
    mobileNumber: "",
    email: "",
    gender: "",
    house_no: "",
    area: "",
    location: "",
    location_id: "",
    state: "",
    landmark: "",
    country: 1,
    lat: "",
    lng: "",
    // time: "",
    status: 0,
    payment: 0,
  });
  const [loading, setLoading] = useState(false);
  const [serviceLoading, setServiceLoading] = useState(false);
  const [selectedService, setSelectedService] = useState(service?.[0] || {});
  const [initialServiceData, setInitialServiceData] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [activeType, setActiveType] = useState("null");
  const [groupedData, setGroupedData] = useState({});
  const sectionsRef = useRef({});
  const scrollContainerRef = useRef(null);
  const isScrollingRef = useRef(false);
  let isScroll = false;
  const [dateSelect, setDateSelect] = useState("");
  const [timeSelect, setTimeSelect] = useState("");
  // Backend/ISO time strings come back as "HH:MM:SS" while the hourly
  // picker buttons/select use "HH:MM" — normalizing everywhere timeSelect
  // gets set from a raw string keeps clicking a calendar slot, editing an
  // existing booking, and the picker all storing (and later comparing/
  // saving) the same format instead of silently drifting to "17:00:00".
  const toHHMM = (t) => (t || "").split(":").slice(0, 2).join(":");
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [otp, setOtp] = useState("");
  const [errorMessages, setErrorMessage] = useState("");
  const [timeRange, setTimeRange] = useState({ startTime: "", endTime: "" });

  const [userId, setUserId] = useState(null);
  const [locationId, setLocationId] = useState(null);
  const [Otpres, setOTPresult] = useState(null);
  const renderOtpInput = (props) => <input {...props} />;
  const [loader, setLoader] = useState(false);
  const [discount, setDiscount] = useState(0);
  const [priceSection, setPriceSection] = useState([]);
  const [showCalender, setShowCalender] = useState(false);
  const [providerSelected, setProviderSelected] = useState([]);
    const [locationError, setLocationError] = useState("");
  // Doctor + slot picker (industry 1 / clinic bookings only) — same
  // getWokerAvailableSlots source NewAppointment.jsx uses for its own
  // Doctor Name field, adapted here for a single-doctor, single-slot pick
  // rather than the crew-calendar flow the rest of this file's dead
  // getWorkerAvailableSlots/BookingCalendar code was built for.
  const [clinicDoctors, setClinicDoctors] = useState([]);
  const [clinicSlots, setClinicSlots] = useState([]);
  const [selectedDoctorId, setSelectedDoctorId] = useState(null);
  const [clinicTimeSlots, setClinicTimeSlots] = useState([]);
  const [selectedSlotLabel, setSelectedSlotLabel] = useState("");
  
  // const isEditing = Boolean(id);
  let navigate = useNavigate();
  const { vendor, refreshVendorData } = useContext(UserContext);
  const [activeAccordion, setActiveAccordion] = useState(
    group_id ? ["1"] : ["0"] // can have multiple keys open
  );
  const [currency, setCurrency] = useState("AED");
  // Stepper presentation state (view only). ?legacy=1 opens the original accordion layout.
  const [legacyLayout] = useState(() => wantsLegacyPublicForm());
  const [stepIndex, setStepIndex] = useState(0);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [invalidSteps, setInvalidSteps] = useState([]);
  // Why the Date & Time step cannot be left, kept beside the time field until a time is
  // picked (the toast alone is easy to miss).
  const [scheduleError, setScheduleError] = useState("");
  useEffect(() => {
    if (timeSelect) setScheduleError("");
  }, [timeSelect]);
  const autocompleteRef = useRef(null);
  
  const onLoad = (autocomplete) => {
    autocompleteRef.current = autocomplete;
  };
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: google_places_key,
    libraries: ["places"],
  });
  const onPlaceChanged = (setFieldValue) => {
    if (!autocompleteRef.current) return;
  
    const place = autocompleteRef.current.getPlace();
    if (!place || !place.address_components) return;
  
    let street = place.formatted_address || "";
    let area = "";
    let state = "";
    let country = "";
    let lat = place.geometry?.location?.lat();
    let lng = place.geometry?.location?.lng();
  
    place.address_components.forEach((comp) => {
      const types = comp.types;
  
      if (types.includes("sublocality") || types.includes("locality")) {
        area = comp.long_name;
      }
  
      if (types.includes("administrative_area_level_1")) {
        state = comp.long_name;
      }
  
      if (types.includes("country")) {
        country = comp.short_name?.toLowerCase(); //  "in" / "ae"
      }
    });
  
    //  expected country based on currency
    const expectedCountry = currency === "INR" ? "in" : "ae";
  
    // console.log("Selected:", country, "Expected:", expectedCountry);
  
    // VALIDATION
    if (!country || country !== expectedCountry) {
      setLocationError(
        currency === "INR"
          ? "Please select a location within India"
          : "Please select a location within UAE"
      );
  
      setFieldValue("location", "");
      setFieldValue("area", "");
      setFieldValue("state", "");
      setFieldValue("lat", "");
      setFieldValue("lng", "");
  
      return;
    }
  
    //  CLEAR ERROR
    setLocationError("");
  
    //  SET VALUES
    const countryObj = countries.find((c) =>
      country === "in"
        ? c.name?.toLowerCase().includes("india")
        : !c.name?.toLowerCase().includes("india")
    );
    const resolvedCountryId = countryObj
      ? Number(countryObj.country_id)
      : currency === "INR"
      ? 2
      : 1;
    setFieldValue("location", street);
    setFieldValue("area", area);
    setFieldValue("state", state);
    setFieldValue("country", resolvedCountryId);
    setFieldValue("lat", lat);
    setFieldValue("lng", lng);
    fetchStates(resolvedCountryId);
  };

  useEffect(() => {
    // vendorDetails loads asynchronously (ezpMyProfile) — wait for it rather
    // than running once on mount with a still-null value, which was locking
    // currency/country to the UAE fallback regardless of the vendor's actual
    // profile currency.
    if (!vendorDetails) return;
    const curr = vendorDetails?.currency;
    setCurrency(curr);
    const defaultCountry = curr === "INR" ? 2 : 1;
    setInitialValues((prev) => ({ ...prev, country: defaultCountry }));
    fetchStates(defaultCountry);
  }, [vendorDetails]);

  // Load Razorpay SDK for INR payments
  useEffect(() => {
    if (currency !== "INR") return;
    if (document.querySelector('script[src*="checkout.razorpay"]')) return;
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.async = true;
    document.body.appendChild(s);
  }, [currency]);

  // Handle Stripe return after payment redirect
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const stripeSession = params.get("stripe_session");
    const gid = params.get("gid");
    if (!stripeSession || !gid) return;
    window.history.replaceState({}, "", window.location.pathname);
    setStripeVerifying(true);
    apicall
      .post({ session_id: stripeSession, group_id: gid }, "complete_stripe_payment")
      .then(async (res) => {
        if (res?.success) {
          // This page reloaded fresh when the browser came back from
          // Stripe's hosted checkout, so modelData (serviceData, patient
          // info, etc.) is empty — it was never populated on this mount.
          // Refetch the actual booking by group_id so the confirmation
          // modal shows real, server-confirmed data instead of blanks.
          try {
            const bookingRes = await apicall.get(`get_ezp_booking_by_id?group_id=${gid}`);
            const rows = bookingRes?.data || [];
            const first = rows[0];
            if (first) {
              setModelData({
                booking_id: first.display_booking_id,
                serviceData: rows.map((r) => ({
                  service_name: r.service_name,
                  service_type_name: r.service_type_name,
                  service_offering_name: r.service_offering_name,
                  added: true,
                })),
                date: first.service_date,
                time: first.service_time,
                userName: first.user_name || first.dependent_name || first.first_name || "",
                mobileNumber: first.phone_number,
                house_no: first.house_no,
                area: first.area,
                location: first.location,
                landmark: first.landmark,
                state: first.state,
                lat: first.lat,
                lng: first.lng,
              });
            }
          } catch (fetchErr) {
            console.log("Failed to refetch booking after Stripe return", fetchErr);
          }
          toast.success(
            isClinicService ? "Payment verified! Appointment confirmed." : "Payment verified! Booking confirmed."
          );
          setShowOrderConf(true);
        } else {
          toast.error("Payment verification failed: " + (res?.message || "Unknown error"));
        }
      })
      .catch(() => toast.error("Could not verify Stripe payment. Contact support."))
      .finally(() => setStripeVerifying(false));
  }, []);

 const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  // Toggle accordion without closing others
  const handleToggleAccordion = (key) => {
    if (activeAccordion.includes(key)) {
      // Remove key if already open (optional: comment this if you don't want closing on header click)
      setActiveAccordion(activeAccordion.filter((k) => k !== key));
    } else {
      // Add key to array
      setActiveAccordion([...activeAccordion, key]);
    }
  };
  const openAccordion1 = () => {
    if (!activeAccordion.includes("1")) {
      setActiveAccordion([...activeAccordion, "1"]);
    }
  };
    const cleanCrewSlots = (slots) => {
    const grouped = {};

    // Step 1: Group by provider_id
    slots.forEach((slot) => {
      const id = slot.extendedProps.provider_id;
      if (!grouped[id]) grouped[id] = [];
      grouped[id].push(slot);
    });

    let result = [];

    // Step 2: Process each crew separately
    Object.values(grouped).forEach((group) => {
      const bookedSlots = group.filter((s) => s.status === 2);

      const cleaned = group.filter((slot) => {
        // keep booked slots
        if (slot.status === 2) return true;

        // remove overlap only within same crew
        const isOverlapping = bookedSlots.some((booked) => {
          return (
            new Date(slot.start) < new Date(booked.end) &&
            new Date(slot.end) > new Date(booked.start)
          );
        });

        return !isOverlapping;
      });

      result.push(...cleaned);
    });

    return result;
  };
    const crewCount = providerSelected?.length || 1;

  const [filteredAppointments, setFilteredAppointments] = useState([
    {
      title: "Worker 1",
      search: "Worker 1",
      start: "2025-11-27T09:00:00",
      end: "2025-11-27T09:30:00",
      status: 10,
      className: "status-15",
      extendedProps: {
        search: "Worker 1",
        start: "2025-11-27T09:00:00",
      },
    },
    {
      title: "Worker 2",
      search: "Worker 2",
      start: "2025-11-27T09:00:00",
      end: "2025-11-27T09:30:00",
      status: 10,

      className: "status-15",
      extendedProps: {
        search: "Worker 1",
        start: "2025-11-27T09:00:00",
      },
    },
    {
      title: "Worker 1",
      search: "Worker 1",
      start: "2025-11-27T10:00:00",
      end: "2025-11-27T10:30:00",
      status: 15,
      className: "status-15",
      extendedProps: {
        search: "Worker 1",
        start: "2025-11-27T10:00:00",
      },
    },
  ]);
  const [initialAppointments, setInitialAppointments] = useState([]);
  const [partner_id, setPartner_id] = useState(1);
  const [partners, setPartners] = useState([]);
  const [user_id, setUser_id] = useState(0);
  const flagCount = useRef(0);
  const pendingSubRef = useRef(null);
  const customerSelectedRef = useRef(false);
  const [bookingStatus, setBookingStatus] = useState([]);
  const [paymentStatus, setPaymentStatus] = useState([]);
  const [firstLocation, setFirstLocation] = useState(null);
  const [existingData, setExistingData] = useState([]);
  const [open, setOpen] = useState(false);
  const [maxTime, setMaxTime] = useState(30);
  const [showOrderConf, setShowOrderConf] = useState(false);
  const [modelData, setModelData] = useState({});
  const [userFlexiSubs, setUserFlexiSubs] = useState([]);
  const [selectedSubscription, setSelectedSubscription] = useState(null);
  const [display_booking_id, setDisplay_booking_id] = useState("");
  const [editable, setEditable] = useState(true);
  const [paymentLoading, setPaymentLoading] = useState(false);
  // "cash" -> OTP verification required before the booking is created.
  // "online" -> no OTP, goes straight to the payment gateway (Razorpay/Stripe).
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("cash");
  const [stripeVerifying, setStripeVerifying] = useState(false);
  const fetchVendorProfile = async () => {
    try {
      const [response] = await Promise.all([
        apicall.get("ezpMyProfile"),
      ]);

      if (response.status === 200 && response.success) {
        const vendorData = response.data[0];
        console.log(vendorData,"vendorData")
        setVendorDetails(vendorData);
      }
    } catch (error) {
      console.error("Error fetching vendor profile:", error);
    }
  };

  useEffect(() => {
    fetchVendorProfile();
  }, []);
  console.log("modelData--", modelData);

  // console.log("timeSelect-------------", timeSelect);

  // Validation Schema
  const validationSchema = Yup.object().shape({
    partner: Yup.string().required("Profile is required"),
    mobileNumber: Yup.string()
      .required("Mobile Number is required")
      // .matches(/^[0-9]+$/, "Phone Number must be numeric")
      .test("country-specific-length", function (value) {
        if (!value) return true;
        const cleanedValue = value.replace(/\D/g, "");
        if (cleanedValue.startsWith("91")) {
          return (
            cleanedValue.length >= 12 ||
            this.createError({
              message:
                "Please enter a valid Indian mobile number (min 10 digits)",
            })
          );
        }
        if (cleanedValue.startsWith("971")) {
          return (
            cleanedValue.length >= 12 ||
            this.createError({
              message: "Please enter a valid UAE mobile number (min 9 digits)",
            })
          );
        }
        // Default: minimum 10 digits (including country code)
        return (
          cleanedValue.length >= 10 ||
          this.createError({
            message: "Please enter a valid mobile number (min 10 digits)",
          })
        );
      })
      .test("country-match-profile", function (value) {
        if (!value) return true;
        const cleanedValue = value.replace(/\D/g, "");
        const wrongPrefix = currency === "INR" ? "971" : "91";
        const expectedCountry = currency === "INR" ? "India" : "UAE";
        if (cleanedValue.startsWith(wrongPrefix)) {
          return this.createError({
            message: `Please select a ${expectedCountry} number — this matches your profile's country.`,
          });
        }
        return true;
      })
      .test("valid-mobile-format", validMobileNumberTest(currency)),
    userName: Yup.string()
      .required(isClinicService ? "Patient name is required" : isSportsService ? "Player name is required" : "Customer name is required")
      .min(2, "Customer name must be at least 2 characters")
      .max(20, "Customer name must not exceed 20 characters"),

    gender: isClinicService
      ? Yup.mixed().required("Gender is required")
      : Yup.mixed(),

    house_no: (isCarService || isClinicService || isSportsService)
      ? Yup.string().max(100, "Street address must not exceed 100 characters")
      : Yup.string()
          .required("Street / House no. is required")
          // .min(5, "Street address must be at least 5 characters")
          .max(100, "Street address must not exceed 100 characters"),

    area: (isCarService || isClinicService || isSportsService)
      ? Yup.string()
      : Yup.string().required("Area is required"),
    location: (isCarService || isClinicService || isSportsService)
      ? Yup.string()
      : Yup.string().required("Location is required"),
   state: (isCarService || isClinicService || isSportsService)
      ? Yup.string()
      : Yup.string().when("country", {
        is: (country) => {
          const selected = countries.find(
            (c) => Number(c.country_id) === Number(country)
          );
          if (selected) return selected.name.toLowerCase().includes("india");
          return currency === "INR";
        },
        then: (schema) => schema.required("State is required"),
        otherwise: (schema) => schema.required("Emirate is required"),
      }),
    country: (isCarService || isClinicService || isSportsService)
      ? Yup.string()
      : Yup.string().required("Country is required"),
    // time: Yup.string().required("Time is required"),

    lat: Yup.string().test(
      "is-valid-latitude",
      "Invalid latitude value",
      (value) => {
        if (!value) return true;
        const numValue = parseFloat(value);
        return !isNaN(numValue) && numValue >= -90 && numValue <= 90;
      }
    ),
    lng: Yup.string().test(
      "is-valid-longitude",
      "Invalid longitude value",
      (value) => {
        if (!value) return true;
        const numValue = parseFloat(value);
        return !isNaN(numValue) && numValue >= -180 && numValue <= 180;
      }
    ),
    // status: Yup.string().required("Status is required"),
    // payment: Yup.string().required("Payment is required"),
  });

  useEffect(() => {
    getAllServices();
  }, [partner_id]);

  useEffect(() => {
    fetchServiceData(selectedService);
  }, [selectedService]);

  useEffect(() => {
    let today = new Date();
    let d1 = today.toLocaleDateString("en-GB").split(/[\/\-\.]/);
    let d2 = `${d1[2]}-${d1[1]}-${d1[0]}`;
    setDateSelect(d2);
    // getAllServices();
    fetchPartners();
  }, [group_id]);

  useEffect(() => {
    const scrollEl = scrollContainerRef.current;
    if (!scrollEl) return;

    const handleScroll = () => {
      if (isScrollingRef.current) return;
      if (isScroll) return;

      // console.log("scroll------");
      const scrollPos = scrollEl.scrollTop; // adjust offset

      for (const type of serviceTypes) {
        const section = sectionsRef.current[type];
        if (section) {
          const { offsetTop, offsetHeight } = section;
          if (scrollPos >= offsetTop && scrollPos < offsetTop + offsetHeight) {
            setActiveType(type);
            break;
          }
        }
      }
    };
    scrollEl.addEventListener("scroll", handleScroll);
    return () => scrollEl.removeEventListener("scroll", handleScroll);
  }, [serviceTypes]);
  // }, [serviceTy/pes]);

  useEffect(() => {
    arrangeData(true);
  }, [initialServiceData]);

  useEffect(() => {
    setProviderSelected([]);
  }, [selectedService]);

  useEffect(() => {
    if (providerSelected?.length > 0) {
      setTimeSelect(toHHMM(providerSelected[0]?.start?.split("T")?.[1]));
    }
  }, [providerSelected]);

  useEffect(() => {
    arrangeData();
    getPrice();
  }, [serviceData]);

  const getStatusColors = (status) => {
    // Define color schemes for different statuses with requested light colors
    const statusColors = {
      //  Green - completed
      1: {
        bgColor: "rgba(255, 255, 204, 0.5)",
        borderColor: "#CCCC00",
        textColor: "#666600",
      },
      //Selected - Light blue
      2: {
        bgColor: "#FFF0FD",
        borderColor: "#92007E",
        textColor: "#92007E",
      },
      // Cancelled / red - Not avaiable
      3: {
        bgColor: "#FDEDED",
        borderColor: "#FF0000",
        textColor: "#FF0000",
      },
      // Break
      6: {
        bgColor: "#FDEDED",
        borderColor: "#FF0000",
        textColor: "#FF0000",
      },

      10: {
        bgColor: "#FDEDED",
        borderColor: "#FF0000",
        textColor: "#FF0000",
      },
      // Checked In (11) - Light blue
      11: {
        bgColor: "#FFF0FD",
        borderColor: "#92007E",
        textColor: "#92007E",
      },
      // Cancelled (14) - Light red
      14: {
        bgColor: "rgba(255, 204, 204, 0.5)",
        borderColor: "#CC0000",
        textColor: "#990000",
      },
      // No Show (15) - Light orange
      12: {
        bgColor: "F2F9FF",
        borderColor: "#037FE8",
        textColor: "#037FE8",
      },
      // Completed/Checked Out (15) - Light green
      15: {
        bgColor: "rgba(255, 255, 204, 0.5)",
        borderColor: "#CCCC00",
        textColor: "#666600",
      },
      // Default - Light gray
      default: {
        bgColor: "rgba(230, 230, 230, 0.5)",
        borderColor: "#999999",
        textColor: "#666666",
      },
    };

    return statusColors[status] || statusColors.default;
  };

  const appointments = filteredAppointments?.map((item) => {
    const colors = getStatusColors(item?.status);

    return {
      title: `${item.title?.trim()}`,
      search: item.title?.trim(),
      start: item?.start,
      end: item?.end,
      backgroundColor: colors.bgColor,
      borderColor: colors.borderColor,
      textColor: colors.textColor,
      extendedProps: {
        ...item,
      },
      // Optional: Add event class for additional styling
      className: `status-${item?.status || "default"}`,
    };
  });

  async function getAllServices() {
    try {
      setLoading(true);
      const response = await apicall.get(
        `get_ezp_service?partner_id=${partner_id}`
      );
      setLoading(false);
      if (response.success && response.data) {
        setServices(response.data);
        if (group_id) {
          getDataByID(response.data);
        } else if (!customerSelectedRef.current) {
          setSelectedService(response.data?.[0]);
          fetchServiceData(response.data?.[0]);

          setInitialValues({
            partner: partner_id,
            org_id: "",
            userName: "",
            mobileNumber: "",
            email: "",
            gender: "",
            house_no: "",
            area: "",
            location: "",
            location_id: "",
            state: "",
            landmark: "",
            country: currency === "INR" ? 2 : 1,
            lat: "",
            lng: "",
            status: "",
            payment: "",
          });
        }
      } else {
        setServices([]);
      }
    } catch (e) {
      console.log("e----", e);
    } finally {
      setLoading(false);
    }
  }

  async function getDataByID(allServicesData) {
    try {
      setLoading(true);
      const response = await apicall.get(
        `get_ezp_booking_by_id?group_id=${group_id}`
      );
      setLoading(false);
      if (response.success && response.data) {
        // console.log("response.data----", response.data);

        setExistingData(response?.data || []);
        let {
          customer_id,
          partner,
          org_id,
          user_name,
          email,
          phone_number,
          house_no,
          area,
          state,
          location,
          location_id,
          landmark,
          status,
          payment,
          lat,
          lng,
          service_id,
          service_date,
          service_time,
          discount,
          provider,
          display_booking_id,
          editable,
          service_type_name,
          country_id,
        } = response.data[0];
        let d1 = {
          partner: partner,
          org_id: org_id,
          userName: user_name,
          mobileNumber: phone_number,
          email: email,
          house_no: house_no,
          area: area,
          location: location,
          location_id: location_id,
          state: state,
          landmark: landmark,
          country: country_id || (currency === "INR" ? 2 : 1),
          lat: lat,
          lng: lng,
          status: status,
          payment: payment,
        };
        setInitialValues(d1);
        setDateSelect(service_date);
        setTimeSelect(toHHMM(service_time));
        setDiscount(discount);
        setPartner_id(partner);
        setDisplay_booking_id(display_booking_id);
        setEditable(editable);
        setUser_id(customer_id);
        setActiveType(service_type_name || "null");

        let providers = provider?.split(",")?.map((ele) => Number(ele));

        let selectedId;
        for (let i of allServicesData) {
          if (i.id === service_id) {
            selectedId = service_id;
            setSelectedService(i);
          }
        }
        let q1 = `getWokerAvailableSlots?date=${service_date}`;
        if (selectedId) {
          q1 += `&&service_id=${selectedId}`;
        }
        // setLoading(true);
        let getWorkerAvailable = await apicall.get(q1);

        let updatedData = getWorkerAvailable?.data || [];

        setInitialAppointments(getWorkerAvailable?.data || []);
        let dt = `${service_date}T${toHHMM(service_time)}:00`;
        // console.log("dt---", dt);

        let p1 = [];
        for (let i of providers) {
          for (let j of updatedData) {
            if (i === j?.extendedProps?.provider_id && dt === j.start) {
              j.status = 2;
              p1.push(j);
            }
          }
        }
        // console.log("p1---", p1);
        setProviderSelected(p1);

        if (!editable) {
          let ans = updatedData.filter((i) => {
            let hours = timeSelect.split(":")[0];
            let mins = timeSelect.split(":")[1];

            let res = i.start.split("T")[1];
            console.log(
              "res--",
              res,
              `${hours}:${mins}:00`,
              res === `${hours}:${mins}:00`
            );
            return res === `${hours}:${mins}:00`;
            //   if (res === `${hours}:${mins}:00`) {
            //   i.start = i.start.split("T")[0] + "T" + `${hours}:${mins}:00`;
            // }
          });
          updatedData = ans;
        }

        setFilteredAppointments(updatedData || []);
      } else {
      }
    } catch (e) {
      console.log("e----", e);
    } finally {
      setLoading(false);
    }
  }

  // console.log("timeSelect==---------", timeSelect);

  function getPrice() {
    try {
      let prices = [];
      let total = 0;
      for (let eachData of serviceData) {
        if (eachData?.added) {
          let name = eachData.service_name + "- ";
          if (
            eachData.service_type_name &&
            eachData.service_type_name !== "null"
          ) {
            name += eachData.service_type_name + "- ";
          }
          name += eachData.service_offering_name;
          prices.push({
            name: name,
            service_id: eachData.service_id,
            service_name: eachData.service_name,
            service_type_id: eachData.service_type_id,
            service_type_name: eachData.service_type_name,
            service_offering_id: eachData.service_offering_id,
            service_offering_name: eachData.service_offering_name,
            amount: eachData.amount,
          });
          total = parseFloat(total) + parseFloat(eachData.amount);
        }
      }
const taxAmount = (parseFloat(total) * taxPercentage) / 100;

      if (prices?.length > 0) {
        prices.push({
          name: `Tax (${taxPercentage}%)`,
           amount: taxAmount.toFixed(2),
        });

        prices.push({
          name: "Discount",
          amount: discount,
        });

        let t1 =
          parseFloat(total) +
          taxAmount-
          parseFloat(discount || 0);
          
        t1 = parseFloat(t1).toFixed(2);

        prices.push({
          name: "Total",
          amount: t1,
        });
      }
      total = 0;

      setPriceSection(prices);
    } catch (e) {
      console.log("e-----", e);
    }
  }

  async function arrangeData(d1) {
    let g1 = serviceData.reduce((acc, item) => {
      // console.log("acc--", acc);
      let { service_type_name } = item;
      // console.log(service_type_name);
      if (!acc[service_type_name]) acc[service_type_name] = [];

      if (d1) item.added = false;
      acc[service_type_name].push(item);
      return acc;
    }, {});

    setServiceTypes(Object.keys(g1));
    setGroupedData(g1);
  }

  useEffect(() => {
    setActiveType(serviceTypes[0] || "null");
  }, []);

  useEffect(() => {
    const initializeData = async () => {
      try {
        await Promise.all([
          fetchCountries(),
          getBookingStatus(),
          getPaymentStatus(),
        ]);
      } catch (error) {
        console.error("Error initializing data:", error);
        toast.error("Failed to initialize form data");
      }
    };

    initializeData();
  }, []);

  const fetchServiceData = async (data, partnerID = null) => {
    try {
      if (data?.service_id) {
        // An explicitly-passed partnerID (e.g. the Profile dropdown's onChange,
        // which fires fetchServiceData in the same handler as setPartner_id)
        // must win over the partner_id state, which is still the OLD value
        // here — setPartner_id hasn't taken effect yet when this line runs.
        let p1 = partnerID != null ? partnerID : partner_id || 1;
        setServiceLoading(true);
        const response = await apicall.get(
          `offeringFromService?service_id=${data?.service_id}&&is_partner=true&&partner_id=${p1}`
        );
        setServiceLoading(false);

        // console.log("existingData----->>>>", existingData);
        let copyResponse;
        if (response?.data) {
          copyResponse = JSON.parse(JSON.stringify(response?.data));
        }

        let offering_id = [];
        let type_name;

        if (response.success && copyResponse) {
          for (let i of existingData) {
            for (let j of copyResponse) {
              if (i.service_offering_id === j.service_offering_id) {
                // console.log("is there-----");
                j.added = true;
                if (!offering_id.includes(i.service_offering_id)) {
                  j.amount = Number(i.price);
                  offering_id.push(i.service_offering_id);
                }
                break;
              }
            }
          }
          // console.log("offering_id---", offering_id);
          console.log("copyResponse---", copyResponse);

          let c1 = copyResponse?.map((ele) => {
            if (offering_id.includes(ele?.service_offering_id)) {
              if (!type_name) {
                type_name = ele?.service_type_name;
                setActiveType(ele?.service_type_name);
              }

              return { ...ele, added: true };
            } else {
              return { ...ele, added: false };
            }
          });

          let sumTime = 0;
          for (let i of copyResponse) {
            if (i?.added) {
              let t1 = i?.time_required + i?.buffer;
              sumTime += t1;
            }
          }
          setMaxTime(sumTime);

          const pendingSub = pendingSubRef.current;
          if (pendingSub) {
            pendingSubRef.current = null;
            const subOfferingId = pendingSub.service_offering_id;
            c1 = c1.map((item) => ({
              ...item,
              added: item.service_offering_id === subOfferingId,
            }));
            setActiveType(pendingSub.service_type_name || "null");
          } else if (!type_name) {
            setActiveType(
              copyResponse[0]?.service_type_name
                ? copyResponse[0]?.service_type_name
                : "null"
            );
          }

          let finalSumTime = 0;
          for (let i of c1) {
            if (i?.added) finalSumTime += (i?.time_required || 0) + (i?.buffer || 0);
          }
          setMaxTime(finalSumTime);
          setServiceData(c1);
        } else {
          setServiceData([]);
        }
      }
    } catch (error) {
      console.log("err---", error);
      toast.error("Failed to fetch service offerings....");
      setInitialServiceData([]);
      setServiceData([]);
    } finally {
      setServiceLoading(false);
    }
  };

  const fetchPartners = async () => {
    try {
      const response = await apicall.get("partners");
      setPartners(response.data);

      if (!group_id) {
        // Profile dropdown only lists the "self" partner, so default to that
        // one (not response.data[0], which may be a different partner and
        // wouldn't match any option in the filtered dropdown).
        const selfPartner = response?.data?.find(
          (p) => p?.partner_name?.trim().toLowerCase() === "self"
        );
        const defaultPartnerId = selfPartner?.id ?? response?.data[0]?.id;
        setPartner_id(defaultPartnerId);
        if (!customerSelectedRef.current) {
          setInitialValues({
            partner: defaultPartnerId,
            org_id: "",
            userName: "",
            mobileNumber: "",
            email: "",
            gender: "",
            house_no: "",
            area: "",
            location: "",
            location_id: "",
            state: "",
            landmark: "",
            country: currency === "INR" ? 2 : 1,
            lat: "",
            lng: "",
            status: "",
            payment: "",
          });
        }
      }
    } catch (error) {
      console.error("Error fetching fetchPartners:", error);
      toast.error("Failed to fetch fetchPartners");
    }
  };

  const getBookingStatus = async () => {
    try {
      const response = await apicall.get("get_ezp_booking_status");

      if (response.success) {
        setBookingStatus(response.data);
      } else {
        setBookingStatus([]);
      }
    } catch (error) {
      console.error("Error fetching Booking Status:", error);
      toast.error("Failed to fetch Booking Status:");
    }
  };

  const getPaymentStatus = async () => {
    try {
      const response = await apicall.get("get_ezp_payment_status");
      if (response.success) {
        setPaymentStatus(response.data);
      } else {
        setPaymentStatus([]);
      }
    } catch (error) {
      console.error("Error fetching Booking Status:", error);
      toast.error("Failed to fetch Booking Status:");
    }
  };

  const fetchCountries = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await apicall.get("country", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.success) {
        const countriesData = Array.isArray(response.data)
          ? response.data
          : response.data?.countries || [];

        setCountries(countriesData);

        // Find UAE in the countries list
        // const uaeCountry = countriesData.find(
        //   (country) =>
        //     country.name.toLowerCase() === "united arab emirates" ||
        //     country.name.toLowerCase() === "uae"
        // );

        // If UAE is found, set it as default
        // if (uaeCountry) {
        //   // setInitialValues((prev) => ({
        //   //   ...prev,
        //   //   country: uaeCountry.country_id.toString(),
        //   // }));
        //   // Fetch states for UAE
        //   fetchStates(uaeCountry.country_id.toString());
        // } else if (countriesData.length > 0) {
        //   // Fallback to first country if UAE not found
        //   // setInitialValues((prev) => ({
        //   //   ...prev,
        //   //   country: countriesData[0].country_id.toString(),
        //   // }));
        //   fetchStates(countriesData[0].country_id.toString());
        // }
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
      toast.error("Failed to fetch countries");
    }
  };

  const fetchStates = async (countryId1) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apicall.get(`state/${countryId1}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.success && response.data) {
        setStates(response.data);
      } else {
        setStates([]);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
      toast.error("Failed to fetch states");
      setStates([]);
    }
  };

  const handleCountryChange = (e, setFieldValue) => {
    const countryId = e.value;

    setFieldValue("country", countryId);
    if (countryId) {
      fetchStates(countryId);
      // Reset state and city when country changes
      // setStates([]);
      // setCities([]);
      // setFieldValue("state", "");
      // setFieldValue("area", "");
    } else {
      // setStates([]);
      // setCities([]);
    }
  };
  useEffect(() => {
    if (initialValues.country) {
      fetchStates(initialValues.country);
    }
  }, [initialValues.country]);
  const handleStateChange = (e, setFieldValue) => {
    const stateId = e.target.value;

    setFieldValue("state", stateId);
    if (stateId) {
      // fetchCities(stateId);
      // Reset city when state changes
      // setCities([]);
      // setFieldValue("city", "");
    } else {
      // setCities([]);
    }
  };

  const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  };

  const get_user_details = async (ph_number, setFieldValue) => {
    const response = await apicall.get(
      `get_users_details/${ph_number}`
    );

    console.log("first---response---", response);

    if (response.status === 200 && response.data.length > 0) {
      const user = response.data[0];
      const fullName = `${user.first_name} ${user.middle_name || ""} ${
        user.last_name || ""
      }`.trim();
      // const age = calculateAge(user.dob);
      const gender =
  user.gender === 1
    ? 1
    : user.gender === 2
    ? 2
    : "";

      setUser_id(user?.id || 0);
      customerSelectedRef.current = true;
      setSelectedSubscription(null);

      // Fetch active Open+Flexi subscriptions for this customer
      if (user.id) {
        apicall.get(`user-flexi-subscriptions/${user.id}`).then((res) => {
          setUserFlexiSubs(Array.isArray(res.data) ? res.data : []);
        }).catch((err) => {
          console.warn("Flexi subscription fetch failed:", err?.message || err);
          setUserFlexiSubs([]);
        });
      }

      // Update form values using Formik's setFieldValue
      setFieldValue("userName", fullName);
      setFieldValue("email", user?.email || "");
      setFieldValue("house_no", user?.house_no || "");
      setFieldValue("area", user?.area || "");
      setFieldValue("landmark", user?.landmark || "");
      setFieldValue("state", user?.state || "");
      setFieldValue("location", user?.location || "");
      setFieldValue("state", user?.state || "");
      // setFieldValue("age", age.toString());
      setFieldValue("lat", user?.lat || "");
      setFieldValue("lng", user?.lng || "");
      setFieldValue("gender", gender);
      setFieldValue("location_id", user?.location_id || "");

      let d1 = {
        house_no: user?.house_no || "",
        area: user?.area || "",
        location: user?.location || "",
        state: user?.state || "",
        landmark: user?.landmark || "",
        lat: user?.lat || "",
        lng: user?.lng || "",
      };
      setFirstLocation(d1);

      // setSelectedUserId(user.id);

      // // Also update formData state for consistency
      // setFormData((prev) => ({
      //   ...prev,
      //   userName: fullName,
      //   age: age.toString(),
      //   gender: gender,
      // }));
    } else {
      setFieldValue("userName", "");
      setFieldValue("age", "");
      setFieldValue("gender", "");
      setUserFlexiSubs([]);
      setSelectedSubscription(null);
      customerSelectedRef.current = false;
    }
  };

  const debouncedCheckUserExists = useCallback(
    debounce(async (field, value, setFieldValue, setFieldError) => {
      try {
        get_user_details(value, setFieldValue);
      } catch (error) {
        console.error(`Error in debounced check for ${field}:`, error);
      }
    }, 500),
    []
  );
  const verifyOtp = async () => {
    if (otp.length !== 6) {
      setErrorMessage("Please enter 6-digit OTP.");
      return;
    }
    try {
      setLoader(true);

      const response = await apicall.post(
        {
          step: "verifyOtp",
          user_id: Otpres.userId,
          mobileNumber: modelData.mobileNumber,
          otp: otp,
          role: Otpres?.role,
          twilioService_id: Otpres.twilioService_id,
        },
        "create_customer_booking"
      );

      if (response?.success) {
        toast.success("OTP Verified");
        setOtp("");
        setShowOtpPopup(false);
        // Cash: OTP is the only verification needed — create the booking
        // right away as pending/collect-in-person, no payment gateway.
        // Clinic bookings use status 5 instead of the normal-flow status 2.
        await createBooking({ payment: 1, status:  isClinicService ? 9 : 2 });
      } else {
        toast.error(response?.message || "Invalid OTP");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoader(false);
    }
  };

const createBooking = async (paymentParams = {}, overrideUserId, overrideLocationId, overrideModelData) => {
  try {
    const baseData = overrideModelData ?? modelData;
    const payload = {
      ...baseData,
      step: "createBooking",
      userId: overrideUserId ?? userId,
      locationId: overrideLocationId ?? locationId,
      ...paymentParams,
    };

    const response = await apicall.post(payload, "create_customer_booking");

    if (response?.success) {
      toast.success(isClinicService ? "Appointment confirmed!" : "Booking confirmed!");
      // modelData is already fully populated at this point (same-page cash/
      // Razorpay flow, no reload in between) — safe for both industries, the
      // confirmation modal itself already has full clinic-specific labels.
      setModelData({ ...baseData, booking_id: response?.booking_id });
      setShowOrderConf(true);
    } else {
      toast.error(response?.message || (isClinicService ? "Appointment failed" : "Booking failed"));
    }
    return response;
  } catch (e) {
    console.log(e);
  }
};

const getCartTotal = () => {
  const t = priceSection?.find((i) => i?.name?.toLowerCase().includes("total"));
  return Number(t?.amount || 0);
};

const handleRazorpayPayment = async (overrideUserId, overrideLocationId, overrideModelData) => {
  try {
    setPaymentLoading(true);
    const bookingData = overrideModelData ?? modelData;
    const total = getCartTotal();
    const orderRes = await apicall.post(
      { amount: total, currency: "INR", vendor_id },
      "create_ezp_payment_order"
    );
    if (!orderRes?.order_id) {
      toast.error("Could not initiate payment. Please try again.");
      setPaymentLoading(false);
      return;
    }
    const options = {
      key: orderRes.key,
      amount: orderRes.amount,
      currency: "INR",
      name: vendorDetails?.first_name || vendorDetails?.fullName || "Service Booking",
      description: "Service Booking",
      order_id: orderRes.order_id,
      prefill: {
        name: bookingData?.userName || "",
        contact: bookingData?.mobileNumber || "",
        email: bookingData?.email || "",
      },
      theme: { color: "#d01c4c" },
      handler: async (response) => {
        try {
          setPaymentLoading(true);
          await createBooking(
            {
              invoice_id: response.razorpay_payment_id,
              payment_gateway: "razorpay",
              payment: 7,
              status: isClinicService ? 9 : 2,
              // status:2,
              total_paid_amount: total,
            },
            overrideUserId,
            overrideLocationId,
            bookingData
          );
        } catch (e) {
          toast.error(isClinicService ? "Appointment failed after payment. Contact support." : "Booking failed after payment. Contact support.");
        } finally {
          setPaymentLoading(false);
        }
      },
      modal: { ondismiss: () => setPaymentLoading(false) },
    };
    const rzp = new window.Razorpay(options);
    rzp.open();
  } catch (e) {
    toast.error("Payment initiation failed.");
    setPaymentLoading(false);
  }
};

const handleStripePayment = async (overrideUserId, overrideLocationId, overrideModelData) => {
  try {
    setPaymentLoading(true);
    const bookingData = overrideModelData ?? modelData;
    const total = getCartTotal();
    const currentUrl = window.location.href.split("?")[0];

    // Create a pending booking first so we have a group_id for Stripe to reference
    const pendingRes = await apicall.post(
      {
        ...bookingData,
        step: "createBooking",
        userId: overrideUserId ?? userId,
        locationId: overrideLocationId ?? locationId,
        payment: 1,
        status: 0,
      },
      "create_customer_booking"
    );
    if (!pendingRes?.success) {
      toast.error("Could not initiate payment. Please try again.");
      setPaymentLoading(false);
      return;
    }
    const groupId = Number(pendingRes.booking_id?.split("_")?.pop()) || null;
    // if (groupId) sessionStorage.setItem("cb_pending_gid", String(groupId));

    const orderRes = await apicall.post(
      {
        amount: total,
        currency: "AED",
        vendor_id,
        group_id: groupId,
        success_return_url: currentUrl,
        cancel_return_url: currentUrl,
      },
      "create_ezp_payment_order"
    );

    if (orderRes?.payment_gateway === "stripe" && orderRes?.session_url) {
      window.location.href = orderRes.session_url;
    } else {
      toast.error("Could not create Stripe session. Please try again.");
      setPaymentLoading(false);
    }
  } catch (e) {
    toast.error("Payment initiation failed.");
    setPaymentLoading(false);
  }
};
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      // setLoading(true);   // button loader

      let flag = true;
      let addedService = serviceData?.filter((ele) => ele?.added);

if (!services || services.length === 0) {
  toast.error(`Please add ${serviceTypeLabel} and Offerings from Admin Setup before ${isClinicService ? "booking an appointment" : "booking"}.`);
  setSubmitting(false); // important
  return;
}

if (!serviceTypes || serviceTypes.length === 0) {
  toast.error("Please configure Service Offerings before proceeding.");
  setSubmitting(false);
  return;
}

if (addedService?.length === 0) {
  toast.error("Select Service Offerings to proceed");
  setSubmitting(false);
  return;
}

if (!timeSelect) {
  toast.error("Select Time");
  setSubmitting(false);
  return;
}

if (isClinicService && (!selectedDoctorId || providerSelected.length === 0)) {
  toast.error("Select Doctor");
  setSubmitting(false);
  return;
}
      if (!flag) return;

      let d1 = {
        house_no: values?.house_no || "",
        area: values?.area || "",
        location: values?.location || "",
        state: values?.state || "",
        landmark: values?.landmark || "",
        lat: values?.lat || "",
        lng: values?.lng || "",
      };

      let isLocationChanged = false;

      if (JSON.stringify(d1) !== JSON.stringify(firstLocation)) {
        isLocationChanged = true;
      }

      let providers = providerSelected?.map(
        (ele) => ele?.extendedProps?.provider_id
      );

      values.editable = editable ? 1 : 0;
      values.date = dateSelect;
      values.isLocationChanged = isLocationChanged;
      values.time = timeSelect;
      values.serviceData = serviceData;
      values.priceSection = priceSection;
      values.providers = providers?.join(", ");
      values.group_id = group_id;
      values.vendor_id = vendor_id;
      values.subscription_id = selectedSubscription ? selectedSubscription.user_subscription_id : null;
      // Tells the backend whether to actually send an OTP — only "cash"
      // requires OTP verification, "online" skips straight to the gateway.
      values.payment_method = selectedPaymentMethod;

      // Clinic bookings don't collect/send address details — build a
      // payload copy that omits them without touching the shared Formik
      // `values` object other industries rely on.
      const payloadValues = isClinicService
        ? (() => {
            const { house_no, area, location, location_id, state, landmark, lat, lng, ...rest } = values;
            return rest;
          })()
        : values;

      setModelData(payloadValues);

      console.log("values---", values);

      const response = await apicall.post(
        { ...payloadValues, step: "createCustomer" },
        "create_customer_booking"
      );
      console.log(response, "response");
      if (response?.success) {
        setUserId(response.userId);
        setLocationId(response.location_id);
        setOTPresult(response);

        if (selectedPaymentMethod === "cash") {
          toast.success("OTP sent to customer mobile");
          setShowOtpPopup(true);
        } else {
          // Online payment — no OTP verification, go straight to the gateway.
          // Pass payloadValues directly instead of relying on modelData state,
          // which hasn't committed yet at this point in the same tick as
          // setModelData(payloadValues) above.
          if (currency === "INR") {
            handleRazorpayPayment(response.userId, response.location_id, payloadValues);
          } else {
            handleStripePayment(response.userId, response.location_id, payloadValues);
          }
        }
      }
      setSubmitting(false);
    } catch (e) {
      console.log(e);
    }
  };

  const addOffering = (data) => {
    try {
      // console.log("data-----", data);
      let t1 = data?.time_required + data?.buffer;

      if (t1 > maxTime) {
        setMaxTime(t1);
      }
      let { service_offering_id } = data;
      let copyServiceData = JSON.parse(JSON.stringify(serviceData));
      for (let eachdata of copyServiceData) {
        if (eachdata?.service_offering_id === service_offering_id) {
          eachdata.added = !eachdata.added;
          break;
        }
      }
      setServiceData(copyServiceData);
    } catch (e) {
      console.log("err----", e);
    }
  };

  function priceChange(value, data) {
    try {
      let copyServiceData = JSON.parse(JSON.stringify(serviceData));

      for (let eachData of copyServiceData) {
        if (eachData.service_offering_id === data?.service_offering_id) {
          eachData.amount = value;
        }
      }
      if (data?.name === "Discount") {
        setDiscount(value);
      }

      setServiceData(copyServiceData);
    } catch (e) {
      console.log("err-----", e);
    }
  }

  const onHide = () => {
    setShowCalender(false);
    flagCount.current = 0;
  };

  // console.log("modelData---", modelData);

  function convertWithoutTimseStamp(date) {
    try {
      const year = date?.getFullYear();
      const month = String(date?.getMonth() + 1).padStart(2, "0");
      const day = String(date?.getDate()).padStart(2, "0");
      const hours = String(date?.getHours()).padStart(2, "0");
      const minutes = String(date?.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day}T${hours}:${minutes}:00`;
    } catch (e) {
      console.log("err---", date, e);
    }
  }

  const handleAppointmentClick = (appointment, currentDate) => {
    console.log(
      "data---handleAppointmentClick---",
      appointment,
      currentDate,
      filteredAppointments
    );
    // console.log("data---filteredAppointments---", appointment?.details?.start);
    let copyFilterData = JSON.parse(JSON.stringify(filteredAppointments));
    let alreadyBookedSlots = copyFilterData.filter((ele) => ele.status === 3);
    // ?.map((ele) => ele.start);

    console.log("alreadyBookedSlots-------", alreadyBookedSlots);

    setDateSelect(appointment?.details?.start?.split("T")?.[0]);
    let agentAssigned = [];

    if (appointment?.details?.status !== 3) {
      copyFilterData?.forEach((eachdata, idx) => {
        if ([3, 6].includes(eachdata?.status)) {
          // continue;
        } else if (appointment?.details?.start !== eachdata.start) {
          eachdata.status = 1;
          let date = new Date(eachdata?.start);
          date.setMinutes(date.getMinutes() + 30);
          eachdata.end = date;
        } else if (
          eachdata?.extendedProps?.provider_id ===
            appointment?.details?.extendedProps?.provider_id &&
          eachdata?.start === appointment?.details?.start &&
          eachdata.status === 2
        ) {
          console.log("not there.......");
          eachdata.status = 1;
          let date = new Date(eachdata?.start);
          date.setMinutes(date.getMinutes() + 30);
          eachdata.end = date;
        } else if (
          eachdata?.extendedProps?.provider_id ===
            appointment?.details?.extendedProps?.provider_id &&
          eachdata?.start === appointment?.details?.start &&
          eachdata.status === 1
        ) {
          // eachdata.status = 2;

          let flag = true;
          for (let i of alreadyBookedSlots) {
            let s1 = new Date(eachdata?.start);
            s1.setMinutes(s1.getMinutes() + maxTime);

            let e1 = new Date(i?.start);
            let e2 = new Date(i?.end);
            console.log("s1,e1,e2------", s1, e1, e2);
            if (
              s1 >= e1 &&
              s1 <= e2 &&
              i?.extendedProps?.provider_id ===
                eachdata?.extendedProps?.provider_id
            ) {
              flag = false;
              console.log("done........");
              break;
            }
          }
          if (flag) eachdata.status = 2;
        }

        if (eachdata?.status === 2) {
          let date = new Date(eachdata?.start);
          date.setMinutes(date.getMinutes() + maxTime);
          eachdata.end = date;

          eachdata.end = convertWithoutTimseStamp(date);

          // console.log("eachData--", eachdata, maxTime);
          agentAssigned.push(eachdata);
        }
      });
    }

    let initial1 = JSON.parse(JSON.stringify(initialAppointments));
    // console.log("before intital----", initialAppointments, initial1);
    // console.log("inti-", initial1, copyFilterData);

    for (let x = 0; x < initialAppointments.length; x++) {
      let i = initial1[x];

      for (let j of copyFilterData) {
        if (
          j.status === 2 &&
          i.start === j.start &&
          i.extendedProps?.provider_id === j.extendedProps?.provider_id
        ) {
          initial1[x] = JSON.parse(JSON.stringify(j)); // <-- correctly updates array
          break;
        }
      }
    }

    // console.log("after intital----", initial1);

    setProviderSelected(agentAssigned);

    let updated = [];

    for (let i of initial1) {
      let flag = true;
      if ([2, 3].includes(i.status)) {
        updated?.push(i);
      } else {
        for (let j of agentAssigned) {
          let s1 = convertWithoutTimseStamp(new Date(i.start));
          let e1 = convertWithoutTimseStamp(new Date(i.end));
          let p1 = i.extendedProps?.provider_id;
          let s2 = convertWithoutTimseStamp(new Date(j.start));
          let e2 = convertWithoutTimseStamp(new Date(j.end));
          let p2 = j.extendedProps?.provider_id;
          if (p1 === p2 && s1 >= s2 && e1 <= e2) {
            flag = false;
            break;
          }
        }
        if (flag) {
          if (editable) {
            updated?.push(i);
          } else {
            let hours = timeSelect.split(":")[0];
            let mins = timeSelect.split(":")[1];

            let res = i.start.split("T")[1];
            console.log(
              "res--",
              res,
              `${hours}:${mins}:00`,
              res === `${hours}:${mins}:00`
            );
            if (res === `${hours}:${mins}:00`) {
              updated?.push(i);
            }
          }
        }
      }
    }
    // console.log("updated--", updated);

    setFilteredAppointments(updated);
  };

  const datesSet = (dateInfo) => {
    try {
      let d1 = dateInfo.startStr?.split("T")?.[0];

      getWorkerAvailableSlots(d1);

      if (![0, 1].includes(flagCount.current)) {
        // console.log("adteIfo---", dateInfo);
      }
      flagCount.current += 1;
    } catch (e) {
      console.log("err---", e);
    }
  };

  // console.log("dateSelect-----", dateSelect);

  const getWorkerAvailableSlots = async (selecDate) => {
    try {
      // console.log("selecDate----", selecDate);
      let d1 = new Date(selecDate);
      d1 = d1.toLocaleDateString("en-GB").split(/[\/\-\.]/);
      d1 = `${d1[2]}-${d1[1]}-${d1[0]}`;
      // console.log("d1---", d1);
      // setDateSelect(d1);
      setLoading(true);
      let q1 = `getWokerAvailableSlots?date=${d1}`;

      // console.log("selectedService---", selectedService);
      if (
        selectedService?.service_id &&
        selectedService?.service_id !== "undefined"
      ) {
        q1 += `&&service_id=${selectedService?.service_id}`;
      }
      let getWorkerAvailable = await apicall.get(q1);

      let updatedData =
        JSON.parse(JSON.stringify(getWorkerAvailable?.data)) || [];

      // console.log("1st.......", getWorkerAvailable?.data);

      setInitialAppointments(getWorkerAvailable?.data || []);

      for (let i of providerSelected) {
        for (let j of updatedData) {
          if (
            i?.start === j?.start &&
            i.extendedProps.provider_id === j.extendedProps.provider_id
          ) {
            j.status = 2;
            let date = new Date(j?.start);
            date.setMinutes(date.getMinutes() + maxTime);
            j.end = date;
          }
        }
      }

      let updated = [];

      for (let i of updatedData) {
        let flag = true;
        if ([2, 3].includes(i.status)) {
          updated?.push(i);
        } else {
          for (let j of providerSelected) {
            let s1 = new Date(i.start);
            let e1 = new Date(i.end);
            let p1 = i.extendedProps?.provider_id;

            let s2 = new Date(j.start);
            let e2 = new Date(j.end);
            let p2 = j.extendedProps?.provider_id;

            if (p1 === p2 && s1 >= s2 && e1 <= e2) {
              flag = false;
              break;
            }
          }
          if (flag) {
            if (editable) {
              updated?.push(i);
            } else {
              let hours = timeSelect.split(":")[0];
              let mins = timeSelect.split(":")[1];

              let res = i.start.split("T")[1];
              // console.log(
              //   "res--",
              //   res,
              //   `${hours}:${mins}:00`,
              //   res === `${hours}:${mins}:00`
              // );
              if (res === `${hours}:${mins}:00`) {
                updated?.push(i);
              }
            }
          }
        }
      }

      // console.log("2nd-------", getWorkerAvailable?.data);

      for (let i of updated) {
        if (i.status === 2) {
          let date = new Date(i?.start);
          let t1 = maxTime / crewCount;
          date.setMinutes(date.getMinutes() + t1);
          i.end = convertWithoutTimseStamp(date);
        }
      }

      let u1 = cleanCrewSlots(updated);

      const result = u1.reduce(
        (acc, item) => {
          return {
            minStart: item.start < acc.minStart ? item.start : acc.minStart,
            maxEnd: item.end > acc.maxEnd ? item.end : acc.maxEnd,
          };
        },
        {
          minStart: u1[0].start,
          maxEnd: u1[0].end,
        }
      );
      let min1 = result?.minStart?.split("T")[1];
      let max1 = result?.maxEnd?.split("T")[1];
      setTimeRange({ startTime: min1, endTime: max1 });

      setFilteredAppointments(u1 || []);
      setShowCalender(true);
      close();
    } catch (e) {
      console.log("err--", e);
    }
  };
const generateTimeSlots = (startHour, endHour, interval) => {
  const slots = [];

  let start = new Date();
  start.setHours(startHour, 0, 0, 0);

  const end = new Date();
  end.setHours(endHour, 0, 0, 0);

  while (start <= end) {
    const hours = start.getHours();   // 0–23 (already 24-hour format)
    const minutes = start.getMinutes();

    const formattedHours = hours.toString().padStart(2, "0");
    const formattedMinutes = minutes.toString().padStart(2, "0");

    slots.push(`${formattedHours}:${formattedMinutes}`);

    start.setMinutes(start.getMinutes() + interval);
  }

  return slots;
};
const timeSlots = generateTimeSlots(8, 17, 60);

  // Fetches which doctors have availability on the picked date for the
  // selected Specialization, and resets whatever doctor/slot was previously
  // chosen — same trigger points (date, Specialization) NewAppointment.jsx
  // re-fetches on for its own Doctor Name field.
  const fetchClinicDoctorSlots = async (date) => {
    if (!date || !selectedService?.service_id) {
      setClinicDoctors([]);
      setClinicSlots([]);
      return;
    }
    try {
      let d1 = new Date(date);
      d1 = d1.toLocaleDateString("en-GB").split(/[\/\-\.]/);
      d1 = `${d1[2]}-${d1[1]}-${d1[0]}`;

      const res = await apicall.get(
        `getWokerAvailableSlots?date=${d1}&&service_id=${selectedService.service_id}`
      );
      const slots = res?.data || [];

      const doctorMap = new Map();
      for (const slot of slots) {
        const providerId = slot?.extendedProps?.provider_id;
        if (providerId && !doctorMap.has(providerId)) {
          doctorMap.set(providerId, {
            id: providerId,
            name: slot?.title || slot?.extendedProps?.search || `Doctor ${providerId}`,
          });
        }
      }
      setClinicDoctors(Array.from(doctorMap.values()));
      setClinicSlots(slots);
    } catch (e) {
      console.log("Error fetching doctor slots", e);
      setClinicDoctors([]);
      setClinicSlots([]);
    } finally {
      setSelectedDoctorId(null);
      setClinicTimeSlots([]);
      setSelectedSlotLabel("");
      setProviderSelected([]);
      setTimeSelect("");
    }
  };

  useEffect(() => {
    if (isClinicService && dateSelect) {
      fetchClinicDoctorSlots(dateSelect);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isClinicService, dateSelect, selectedService?.service_id]);

  // Narrows the date's slot list down to the chosen doctor's own slots —
  // each becomes its own pickable start-time option (e.g. "8:00", then
  // "8:30"), one per slot the backend returned — not a "start - end" range,
  // which was confusing on screen and didn't match what actually gets
  // saved (only the start time is ever sent as `time`/`service_time`).
  const handleClinicDoctorSelect = (doctorId) => {
    setSelectedDoctorId(doctorId);
    setSelectedSlotLabel("");
    setTimeSelect("");
    setProviderSelected([]);

    const doctorSlots = (clinicSlots || []).filter(
      (slot) => slot?.extendedProps?.provider_id === doctorId
    );
    const slots = doctorSlots.map((item) => {
      const start = new Date(item.start);
      const format = (d) => d.toTimeString().slice(0, 5);
      return { label: format(start), start: item.start };
    });
    setClinicTimeSlots(slots);
  };

  // Picking a slot both drives the visible dropdown (selectedSlotLabel) and
  // feeds the same `providerSelected` state handleSubmit already reads to
  // build `values.providers` (line ~1565) — no change needed there.
  const handleClinicSlotSelect = (label) => {
    const chosen = clinicTimeSlots.find((s) => s.label === label);
    if (!chosen) return;
    setSelectedSlotLabel(label);
    setTimeSelect(label);
    setProviderSelected([
      {
        start: chosen.start,
        extendedProps: { provider_id: selectedDoctorId },
        status: 2,
      },
    ]);
  };

  const convertTo12Hour = (time) => {
    if (!time) return "";

    const [hour, minute] = time.split(":");
    const h = parseInt(hour);

    const ampm = h >= 12 ? "PM" : "AM";
    const formattedHour = h % 12 || 12;

    return `${formattedHour}:${minute} ${ampm}`;
  };
    const formatPhoneNumber = (phone, currency) => {
    if (!phone) return "";

    let cleaned = phone.toString().replace(/\D/g, "");

    if (currency === "INR") {
      // Remove India country code if already present
      if (cleaned.startsWith("91") && cleaned.length > 10) {
        cleaned = cleaned.slice(2);
      }

      return `+91 ${cleaned.slice(0, 5)} ${cleaned.slice(5)}`;
    }

    if (currency === "AED") {
      // Remove UAE country code if already present
      if (cleaned.startsWith("971") && cleaned.length > 9) {
        cleaned = cleaned.slice(3);
      }

      return `+971 ${cleaned.slice(0, 2)} ${cleaned.slice(2)}`;
    }

    return phone;
  };
  const onHideOrderConf = () => {
    setShowOrderConf(false);
    window.location.reload();
    // navigate("/dashboard");
  };

  // if (loading && isEditing) {
  //   return (
  //     <div
  //       className="d-flex justify-content-center align-items-center"
  //       style={{ height: "400px" }}
  //     >
  //       <Spinner animation="border" variant="danger" />
  //     </div>
  //   );
  // }
  const formatDateDisplay = (date) => {
    if (!date) return "";

    return new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  function close() {
    setOpen(false);
  }


  // The form body, shared by the guided stepper (default) and the original accordion page
  // (?legacy=1). Every field, handler, rule and API call in the blocks below is the page's
  // original - only the way they are arranged differs between the two layouts.
  const renderForm = ({
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    setValues,
    setFieldError,
    setFieldTouched,
    setTouched,
    validateForm,
    submitForm,
  }) => {
    const blockService = (
      <>
                              {/* ================= CARD 1 ================= */}
                              {/* SERVICE TYPE + OFFERING */}
                              <div className="service-selection-card mb-4">
                                <div className="mb-4">
                                  <Col md={4} className="mb-2">
                                    <Form.Group>
                                      <Form.Label>
                                        Profile
                                        <FieldHelpTooltip
                                          {...HELP_CONTENT.bookings.profile}
                                        />
                                      </Form.Label>
                                      <Form.Select
                                        name="partner"
                                        value={values.partner}
                                        onChange={(e) => {
                                          handleChange(e);
                                          setPartner_id(e.target.value);
                                          fetchServiceData(
                                            selectedService,
                                            e.target.value
                                          );
                                        }}
                                        onBlur={handleBlur}
                                        isInvalid={
                                          touched.partner && errors.partner
                                        }
                                        className={`form-input ${
                                          values.partner === ""
                                            ? "placeholder-style"
                                            : ""
                                        }`}
                                        style={{
                                          height: "40px",
                                          backgroundColor: "white",
                                          border:
                                            touched.partner && errors.partner
                                              ? "1px solid #dc3545"
                                              : "1px solid #E9ECEF"
                                        }}
                                      >
                                        <option value="">Select Profile</option>
                                        {partners
                                          ?.filter(
                                            (partner) =>
                                              partner?.partner_name
                                                ?.trim()
                                                .toLowerCase() === "self"
                                          )
                                          .map((partner) => (
                                            <option
                                              key={partner?.id}
                                              value={partner?.id}
                                            >
                                              {partner?.partner_name}
                                            </option>
                                          ))}
                                      </Form.Select>

                                      {touched.partner && errors.partner && (
                                        <div className="invalid-feedback d-block">
                                          {errors.partner}
                                        </div>
                                      )}
                                    </Form.Group>
                                  </Col>
                                </div>
                                {/* SERVICE TYPE */}
                             <div className="mb-4">
                            <h6 className="section-title">
                              {serviceCategoryLabel}
                              <span style={{ color: "red", fontSize: "1rem" }}>
                                *
                              </span>
                            </h6>

                            {services && services.length > 0 ? (
                              <div className="d-flex gap-3 flex-wrap">
                                {services.map((ele) => (
                                  <div
                                    key={ele.service_id}
                                    onClick={() => setSelectedService(ele)}
                                    className={`service-type-pill ${
                                      ele?.service_id ===
                                      selectedService?.service_id
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    {ele?.service_name}
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <div className="text-center p-4 border rounded bg-light">
                                <h6 className="text-danger mb-2">
                                  No Services Available
                                </h6>
                                <p className="text-muted mb-0">
                                  Please add {serviceCategoryLabel} & {serviceTypeLabel} from Admin Setup to
                                  continue {isClinicService ? "booking an appointment" : "booking"}.
                                </p>
                              </div>
                            )}
                          </div>
                          {serviceLoading && (
                            <div className="d-flex align-items-center gap-2 my-2" style={{ fontSize: "13px", color: "#6B7280" }}>
                              {/* <Spinner animation="border" size="sm" variant="danger" />
                              Loading services… */}
                            </div>
                          )}
                          {/* SERVICE TYPE */}
                          {!Object.keys(groupedData).includes("null") && (
                            <div className="mb-4">
                              <h6 className="section-title">
                                Sub Category
                                <span
                                  style={{ color: "red", fontSize: "1rem" }}
                                >
                                  *
                                </span>
                              </h6>

                              <div className="d-flex gap-3 flex-wrap">
                                {Object.keys(groupedData).map((ele) => (
                                  <div
                                    key={ele}
                                    onClick={() => setActiveType(ele)}
                                    className={`service-type-pill ${
                                      ele === activeType ? "active" : ""
                                    }`}
                                  >
                                    {ele}
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}

                          {/* SELECT OFFERING */}
                          {services?.length > 0 && (
                            <>
                              {serviceTypes && serviceTypes.length > 0 ? (
                                <div>
                                  <h6 className="section-title">
                                    {serviceTypeLabel}
                                    <span
                                      style={{ color: "red", fontSize: "1rem" }}
                                    >
                                      *
                                    </span>
                                  </h6>

                                  <div className="row g-3">
                                    {groupedData?.[activeType]?.map((data) => (
                                      <div className="col-md-3" key={data.id}>
                                        <div
                                          onClick={() => addOffering(data)}
                                          className="offering-row-card d-flex justify-content-between align-items-center"
                                        >
                                          <div>
                                            <div className="fw-semibold">
                                              {data?.service_offering_name}
                                            </div>
                                            <div className="price-text">
                                              {currency} {data?.price}
                                            </div>
                                          </div>

                                          <div
                                            className={`btn btn-sm rounded-3 ${
                                              data?.added
                                                ? "btn-danger"
                                                : "btn-outline-danger"
                                            }`}
                                          >
                                            {data?.added ? "Added" : "Add"}
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              ) : (
                                <div className="text-center p-4 border rounded bg-light">
                                  <h6 className="text-danger mb-2">
                                    No {serviceTypeLabel}s Available
                                  </h6>
                                  <p className="text-muted mb-0">
                                    Please add {serviceTypeLabel} under the selected
                                    {" "}{serviceCategoryLabel} to continue {isClinicService ? "booking an appointment" : "booking"}.
                                  </p>
                                </div>
                              )}
                            </>
                          )}
                        </div>

                              {/* ================= SUBSCRIPTION CARD ================= */}
                              {userFlexiSubs.length > 0 && (
                                <div className="service-selection-card mb-4">
                                  <h6 className="section-title">
                                    Apply Subscription{" "}
                                    <span style={{ fontSize: "12px", fontWeight: "400", color: "#6B7280" }}>
                                      (optional)
                                    </span>
                                  </h6>
                                  <Form.Select
                                    value={selectedSubscription ? selectedSubscription.user_subscription_id : ""}
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      if (!val) {
                                        setSelectedSubscription(null);
                                        pendingSubRef.current = null;
                                        fetchServiceData(selectedService);
                                      } else {
                                        const sub = userFlexiSubs.find(
                                          (s) => String(s.user_subscription_id) === val
                                        );
                                        if (sub) {
                                          setSelectedSubscription(sub);
                                          pendingSubRef.current = sub;
                                          const matchedService = services?.find(
                                            (s) => String(s.service_id) === String(sub.service_id)
                                          );
                                          if (matchedService) {
                                            if (String(matchedService.service_id) === String(selectedService?.service_id)) {
                                              fetchServiceData(matchedService);
                                            } else {
                                              setSelectedService(matchedService);
                                            }
                                          }
                                        }
                                      }
                                    }}
                                    style={{ maxWidth: "420px", height: "40px" }}
                                  >
                                    <option value="">— None (no subscription) —</option>
                                    {userFlexiSubs.map((sub) => (
                                      <option key={sub.user_subscription_id} value={sub.user_subscription_id}>
                                        {sub.plan_name} — {sub.service_name}
                                        {sub.service_offering_name ? ` / ${sub.service_offering_name}` : ""}
                                      </option>
                                    ))}
                                  </Form.Select>

                                  {selectedSubscription && (
                                    <div
                                      style={{
                                        marginTop: "12px",
                                        padding: "12px 16px",
                                        background: "#FDE8EF",
                                        borderRadius: "10px",
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "20px",
                                        fontSize: "13px",
                                        color: "#374151",
                                      }}
                                    >
                                      {[
                                        { label: "Plan", value: selectedSubscription.plan_name },
                                        { label: "Service", value: selectedSubscription.service_name },
                                        selectedSubscription.service_type_name && { label: "Sub Category", value: selectedSubscription.service_type_name },
                                        selectedSubscription.service_offering_name && { label: serviceTypeLabel, value: selectedSubscription.service_offering_name },
                                        { label: "Pricing", value: `${currency} ${Number(selectedSubscription.pricing || 0).toFixed(2)}` },
                                        { label: "Sessions", value: selectedSubscription.number_of_sessions === "Limited" ? `${selectedSubscription.total_sessions} sessions` : selectedSubscription.number_of_sessions || "-" },
                                        { label: "Plan End", value: selectedSubscription.plan_end_date ? new Date(selectedSubscription.plan_end_date).toLocaleDateString() : "-" },
                                      ].filter(Boolean).map(({ label, value }) => (
                                        <div key={label}>
                                          <div style={{ fontWeight: "600", color: "#C0335A", fontSize: "11px", textTransform: "uppercase", marginBottom: "2px" }}>{label}</div>
                                          <div style={{ fontWeight: "600", color: "#111827" }}>{value}</div>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              )}
      </>
    );
    const blockSchedule = (
      <>
                              {/* ================= CARD 2 ================= */}
                              {/* SERVICE INFORMATION */}
                              <div className="service-summary-card">
                                <div className="p-3">
                                  {/* DATE + TIME + CREW + STATUS + PAYMENT */}
                                  {/* Start Date */}
                                  <Row>
                                    <Col
                                      md={3}
                                      style={{ marginBottom: "1%" }}
                                      // onClick={(e) => e.stopPropagation()}
                                    >
                                      <div className="d-flex  flex-column">
                                        <Form.Label>Select Date
                                           <span style={{ color: "red" }}>*</span>
                                        </Form.Label>
                                         <div className="position-relative" ref={wrapperRef}>
      <button
        type="button"
        className="btn d-flex align-items-center gap-2 px-3 position-relative"
        style={{
          height: "40px",
          fontSize: "14px",
          borderRadius: "6px",
          backgroundColor: "#FFFFFF",
          border: "1px solid #E3EBF8",
          color: "#000000",
          justifyContent: "space-between",
          width: "100%",
        }}
        onClick={(e) => {
          e.stopPropagation(); // ✅ prevent outside click trigger
          setOpen((prev) => !prev); // toggle
        }}
      >
        {formatDateDisplay(dateSelect)}
        <FaRegCalendarAlt className="position-absolute end-0 mx-2" />
      </button>

      {open && (
        <div
          onClick={(e) => e.stopPropagation()} // ✅ prevent closing when clicking inside
          style={{
            position: "absolute",
            top: "100%",
            left: "0",
            zIndex: 9999,
            backgroundColor: "#fff",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            borderRadius: "8px",
            marginTop: "5px",
          }}
        >
          <DatePicker
            inline
            selected={dateSelect}
            onChange={(date) => {
              setDateSelect(date);
              setOpen(false); // ✅ close after select
            }}
            dateFormat="dd-MM-yyyy"
          />
        </div>
      )}
    </div>
                                      </div>
                                    </Col>

                                    {/* Doctor selection — clinic (industry 1) bookings only.
                                        Availability is date + Specialization scoped, so this only
                                        lists doctors up via fetchClinicDoctorSlots once a date is
                                        picked, same source NewAppointment.jsx's Doctor Name field
                                        uses (getWokerAvailableSlots). */}
                                    {isClinicService && (
                                      <Col md={3} style={{ marginBottom: "1%" }}>
                                        <div className="d-flex flex-column">
                                          <Form.Label>Select Doctor
                                             <span style={{ color: "red" }}>*</span>
                                          </Form.Label>
                                          <Form.Select
                                            value={selectedDoctorId || ""}
                                            onChange={(e) =>
                                              handleClinicDoctorSelect(Number(e.target.value) || null)
                                            }
                                            disabled={!dateSelect}
                                            style={{ height: "40px" }}
                                          >
                                            <option value="">
                                              {!dateSelect
                                                ? "Select a date first"
                                                : clinicDoctors.length === 0
                                                ? "No Doctors Available"
                                                : "Select Doctor"}
                                            </option>
                                            {clinicDoctors.map((d) => (
                                              <option key={d.id} value={d.id}>
                                                {d.name}
                                              </option>
                                            ))}
                                          </Form.Select>
                                        </div>
                                      </Col>
                                    )}

                                    {/* Selected Time */}
                                    {/* <Col md={9}>
  <div className="d-flex flex-column">
    <Form.Label>Select Time</Form.Label>

    <div className="d-flex flex-wrap gap-2">
      {timeSlots.map((time, index) => (
        <button
          key={index}
          type="button"
          className={`btn btn-sm ${
            timeSelect === time ? "btn-danger" : "btn-outline-danger"
          }`}
          onClick={() => setTimeSelect(time)}
        >
          {convertTo12Hour(time)}
        </button>
      ))}
    </div>
  </div>
</Col> */}
                                    <Col md={3}>
                                      <div className="d-flex flex-column">
                                        <Form.Label>Select Time
                                           <span style={{ color: "red" }}>*</span>
                                        </Form.Label>

                                        {isClinicService ? (
                                          <Form.Select
                                            value={selectedSlotLabel || ""}
                                            onChange={(e) => handleClinicSlotSelect(e.target.value)}
                                            disabled={!selectedDoctorId}
                                            style={{ height: "40px" }}
                                          >
                                            <option value="">
                                              {!selectedDoctorId
                                                ? "Select Time"
                                                : clinicTimeSlots.length === 0
                                                ? "No slots available"
                                                : "Select Time"}
                                            </option>
                                            {clinicTimeSlots.map((slot, index) => (
                                              <option key={index} value={slot.label}>
                                                {slot.label}
                                              </option>
                                            ))}
                                          </Form.Select>
                                        ) : (
                                          <Form.Select
                                            value={timeSelect || ""}
                                            onChange={(e) =>
                                              setTimeSelect(e.target.value)
                                            }
                                            style={{ height: "40px" }}
                                          >
                                            <option value="">Select Time</option>

                                            {timeSlots.map((time, index) => (
                                              <option key={index} value={time}>
                                                {time}
                                              </option>
                                            ))}
                                          </Form.Select>
                                        )}
                                        {scheduleError && !timeSelect && (
                                          <div className="pbk-field-error" role="alert" data-testid="schedule-error">
                                            {scheduleError}
                                          </div>
                                        )}
                                      </div>
                                    </Col>
                                    {legacyLayout && (
                                      <Col md={3}>
                                        <button className="btn btn-danger" onClick={openAccordion1} style={{marginTop:"20px"}}>
                                          Next
                                        </button>
                                      </Col>
                                    )}
                                  </Row>
                                </div>
                              </div>
      </>
    );
    const blockPersonal = (
      <>
                              <div className="mb-4">
                                {/* <h6 className="mb-4 section-heading">Personal Details</h6> */}
                                <Row className="mb-4">
                                  <Col md={4}>
                                    <Form.Group>
                                      <Form.Label>{isClinicService ? "Patient Name" : isSportsService ? "Player Name" : "Customer Name"}
                                         <span style={{ color: "red" }}>*</span>
                                      </Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="userName"
                                        placeholder={isClinicService ? "Enter Patient Name..." : isSportsService ? "Enter Player Name..." : "Enter Customer Name..."}
                                        value={values.userName}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        disabled={!editable}
                                        isInvalid={
                                          touched.userName && errors.userName
                                        }
                                        className="form-input"
                                      />
                                      {touched.userName && errors.userName && (
                                        <Form.Control.Feedback type="invalid">
                                          {errors.userName}
                                        </Form.Control.Feedback>
                                      )}
                                    </Form.Group>
                                  </Col>
                                  <Col md={4}>
                              <Form.Group>
                                <Form.Label>
                                  Mobile Number
                                  <span style={{ color: "red" }}>*</span>
                                </Form.Label>
                                <PhoneInput
                                  country={currency === "INR" ? "in" : "ae"}
                                  // country={phoneCountryCode}
                                  onlyCountries={["ae", "in"]}
                                  value={values.mobileNumber}
                                  disabled={!editable}
                                  onChange={(value) => {
                                    const cleanedValue = value.replace(
                                      /\D/g,
                                      ""
                                    );
                                    setFieldValue("mobileNumber", cleanedValue);
                                    setFieldTouched("mobileNumber", true, false);

                                    // Only check for user existence if the number is valid
                                    if (cleanedValue.length >= 12) {
                                      debouncedCheckUserExists(
                                        "mobileNumber",
                                        cleanedValue,
                                        setFieldValue,
                                        setFieldError
                                      );
                                    }
                                  }}
                                  inputStyle={{
                                    width: "100%",
                                    height: "40px",
                                    backgroundColor: "white",
                                    borderColor:
                                      touched.mobileNumber && errors.mobileNumber
                                        ? "#dc3545"
                                        : "#E9ECEF",
                                  }}
                                  inputProps={{
                                    name: "mobileNumber",
                                    // required: true,
                                  }}
                                />
                                {touched.mobileNumber && errors.mobileNumber && (
                                  <div className="invalid-feedback d-block">
                                    {errors.mobileNumber}
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                                  <Col md={4}>
                                    <Form.Group>
                                      <Form.Label>Email Address</Form.Label>
                                      <Form.Control
                                        type="email"
                                        name="email"
                                        placeholder="Enter email address"
                                        value={values.email}
                                        disabled={!editable}
                                        onChange={(e) => {
                                          handleChange(e);
                                          const value = e.target.value;
                                          setFieldTouched("email", true, false);
                                          if (
                                            !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                                              value
                                            )
                                          ) {
                                            setFieldError(
                                              "email",
                                              "Invalid email format"
                                            );
                                          }
                                        }}
                                        onBlur={handleBlur}
                                        isInvalid={
                                          touched.email && errors.email
                                        }
                                        className="form-input"
                                      />
                                      {touched.email && errors.email && (
                                        <Form.Control.Feedback type="invalid">
                                          {errors.email}
                                        </Form.Control.Feedback>
                                      )}
                                    </Form.Group>
                                  </Col>
                                  {isClinicService && (
                                    <Col md={4}>
                                      <Form.Group>
                                        <Form.Label>Gender
                                           <span style={{ color: "red" }}>*</span>
                                        </Form.Label>
                                        <Dropdown
                                          name="gender"
                                          value={values.gender || null}
                                          options={[
                                            { label: "Male", value: 1 },
                                            { label: "Female", value: 2 },
                                          ]}
                                          placeholder="Select Gender"
                                          onChange={(e) => setFieldValue("gender", e.value)}
                                          onBlur={handleBlur}
                                          disabled={!editable}
                                          className={`w-100 ${
                                            touched.gender && errors.gender ? "is-invalid" : ""
                                          }`}
                                          style={{
                                            height: "40px",
                                            backgroundColor: "white",
                                            border:
                                              touched.gender && errors.gender
                                                ? "1px solid #dc3545"
                                                : "1px solid #E9ECEF",
                                          }}
                                        />
                                        {touched.gender && errors.gender && (
                                          <div className="invalid-feedback d-block">
                                            {errors.gender}
                                          </div>
                                        )}
                                      </Form.Group>
                                    </Col>
                                  )}
                                </Row>
                              </div>
      </>
    );
    const blockAddress = (
      <>
                                {!isCarService && !isClinicService && !isSportsService && (
                                <>
                                <h6 className="section-heading"> Full Address</h6>
                                <Row className="g-3">
                               <Col md={4}>
                                                            <Form.Group>
                                                              <Form.Label>
                                                                Address{" "}
                                                                <span style={{ color: "red" }}>*</span>
                                                              </Form.Label>
                              
                                                              <div className="d-flex align-items-center gap-2">
                                                                <div style={{ flex: 1 }}>
                                                                  {isLoaded && (
                                                                    <Autocomplete
                                                                      onLoad={onLoad}
                                                                      onPlaceChanged={() =>
                                                                        onPlaceChanged(setFieldValue)
                                                                      }
                                                                      options={{
                                                                        componentRestrictions: {
                                                                          country:
                                                                            currency === "INR" ? "in" : "ae",
                                                                        },
                                                                      }}
                                                                    >
                                                                      <Form.Control
                                                                        type="text"
                                                                        name="location"
                                                                        placeholder="Search address"
                                                                        value={values.location}
                                                                        onChange={handleChange}
                                                                        className="form-input"
                                                                      />
                                                                    </Autocomplete>
                                                                  )}
                                                                </div>
                              
                                                                {values.location && (
                                                                  <button
                                                                    type="button"
                                                                    className="btn btn-outline-danger btn-sm"
                                                                    onClick={() => {
                                                                      setFieldValue("location", "");
                                                                      setFieldValue("area", "");
                                                                      setFieldValue("state", "");
                                                                      setFieldValue("lat", "");
                                                                      setFieldValue("lng", "");
                                                                    }}
                                                                  >
                                                                    ✖
                                                                  </button>
                                                                )}
                                                              </div>
                              
                                                              {touched.location && errors.location && (
                                                                <div className="invalid-feedback d-block">
                                                                  {errors.location}
                                                                </div>
                                                              )}
                                                            </Form.Group>
                                                          </Col>
<Col md={4}>
  <Form.Group>
    <Form.Label>
      House / Flat / Building No
      <span style={{ color: "red" }}>*</span>
    </Form.Label>

    <Form.Control
      type="text"
      name="house_no"
      placeholder="Enter house / flat / building no"
      value={values.house_no}
      onChange={handleChange}
      onBlur={handleBlur}
      disabled={!editable}
      isInvalid={touched.house_no && errors.house_no}
      className="form-input"
      style={{ height: "40px" }}
    />

    {touched.house_no && errors.house_no && (
      <div className="invalid-feedback d-block">
        {errors.house_no}
      </div>
    )}
  </Form.Group>
</Col>
                                  <Col md={4}>
                                    <Form.Group>
                                      <Form.Label>Area
                                         <span style={{ color: "red" }}>*</span>
                                      </Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="area"
                                        placeholder="Enter area details..."
                                        value={values.area}
                                        onChange={handleChange}
                                        disabled={!editable}
                                        onBlur={handleBlur}
                                        isInvalid={touched.area && errors.area}
                                        className="form-input"
                                        style={{ height: "40px" }}
                                      />
                                      {touched.area && errors.area && (
                                        <div className="invalid-feedback d-block">
                                          {errors.area}
                                        </div>
                                      )}
                                    </Form.Group>
                                  </Col>
                                  {/* <Col md={4}>
                                    <Form.Group>
                                      <Form.Label>Location
                                         <span style={{ color: "red" }}>*</span>
                                      </Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="location"
                                        placeholder="Enter location details..."
                                        value={values.location}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        disabled={!editable}
                                        isInvalid={
                                          touched.location && errors.location
                                        }
                                        className="form-input"
                                        style={{ height: "40px" }}
                                      />
                                      {touched.location && errors.location && (
                                        <div className="invalid-feedback d-block">
                                          {errors.location}
                                        </div>
                                      )}
                                    </Form.Group>
                                  </Col> */}

                               <Col md={4}>
                                                         <Form.Group>
                                                           <Form.Label>
                                                             {countries.find(c => Number(c.country_id) === Number(values.country))?.name?.toLowerCase().includes("india") ? "State" : "Emirate"}
                                                             <span
                                                               style={{ color: "red", fontSize: "1rem" }}
                                                             >
                                                               *
                                                             </span>
                                                           </Form.Label>
                                                           {/* <Form.Select
                                                         name="state"
                                                         value={values.state}
                                                         onChange={(e) =>
                                                           handleStateChange(e, setFieldValue)
                                                         }
                                                         onBlur={handleBlur}
                                                         isInvalid={touched.state && errors.state}
                                                         className={`form-input ${
                                                           values.state === "" ? "placeholder-style" : ""
                                                         }`}
                                                         style={{
                                                           height: "40px",
                                                           backgroundColor: "white",
                                                           border:
                                                             touched.state && errors.state
                                                               ? "1px solid #dc3545"
                                                               : "1px solid #E9ECEF",
                                                         }}
                                                       >
                                                         <option value="">Select Emirate</option>
                                                         {states.map((state) => (
                                                           <option key={state.name} value={state.name}>
                                                             {state.name}
                                                           </option>
                                                         ))}
                                                       </Form.Select> */}
                                                           <Dropdown
                                                             name="state"
                                                             value={values.state}
                                                             options={states?.map((s) => ({
                                                               label: s.name,
                                                               value: s.name,
                                                             }))}
                                                             placeholder={
                                                               countries.find(c => Number(c.country_id) === Number(values.country))?.name?.toLowerCase().includes("india")
                                                                 ? "Select State"
                                                                 : "Select Emirate"
                                                             }
                                                             disabled={!editable}
                                                             onChange={(e) => {
                                                               // console.log("Selected Emirate:", e.value);
                           
                                                               handleStateChange(e, setFieldValue); // your existing function
                                                               setFieldValue("state", e.value);
                                                             }}
                                                             onBlur={handleBlur}
                                                             className={`w-100 ${
                                                               touched.state && errors.state
                                                                 ? "is-invalid"
                                                                 : ""
                                                             }`}
                                                             style={{
                                                               height: "40px",
                                                               backgroundColor: "white",
                                                               border:
                                                                 touched.state && errors.state
                                                                   ? "1px solid #dc3545"
                                                                   : "1px solid #E9ECEF",
                                                             }}
                                                           />
                           
                                                           {touched.state && errors.state && (
                                                             <div className="invalid-feedback d-block">
                                                               {errors.state}
                                                             </div>
                                                           )}
                                                         </Form.Group>
                                                       </Col>

                                  <Col md={4}>
                                    <Form.Group>
                                      <Form.Label>Landmark</Form.Label>
                                      <Form.Control
                                        type="text"
                                        name="landmark"
                                        placeholder="Enter landmark details..."
                                        value={values.landmark}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        disabled={!editable}
                                        isInvalid={
                                          touched.landmark && errors.landmark
                                        }
                                        className="form-input"
                                        style={{ height: "40px" }}
                                      />
                                      {touched.landmark && errors.landmark && (
                                        <div className="invalid-feedback d-block">
                                          {errors.landmark}
                                        </div>
                                      )}
                                    </Form.Group>
                                  </Col>

                                     <Col md={4}>
                                                                <Form.Group>
                                                                  <Form.Label>Country</Form.Label>
                                                                  <Dropdown
                                                                    name="country"
                                                                    value={Number(values.country)}
                                                                    options={countries?.map((c) => ({
                                                                      label: c.name,
                                                                      value: Number(c.country_id),
                                                                    }))}
                                                                    placeholder="Select Country"
                                                                    disabled={!editable}
                                                                    onChange={(e) => {
                                                                      const expectedCountryId = currency === "INR" ? 2 : 1;
                                                                      if (Number(e.value) !== expectedCountryId) {
                                                                        toast.error(
                                                                          currency === "INR"
                                                                            ? "Please select a country related to your profile (India)."
                                                                            : "Please select a country related to your profile (UAE)."
                                                                        );
                                                                        return;
                                                                      }

                                                                      handleCountryChange(e, setFieldValue); // your existing function
                                                                      setFieldValue("country", e.value);
                                                                    }}
                                                                    onBlur={handleBlur}
                                                                    className={`w-100 ${
                                                                      touched.country && errors.country
                                                                        ? "is-invalid"
                                                                        : ""
                                                                    }`}
                                                                    style={{
                                                                      height: "40px",
                                                                      backgroundColor: "white",
                                                                      border:
                                                                        touched.country && errors.country
                                                                          ? "1px solid #dc3545"
                                                                          : "1px solid #E9ECEF",
                                                                    }}
                                                                  />
                                                                  {touched.country && errors.country && (
                                                                    <div className="invalid-feedback d-block">
                                                                      Please select a country
                                                                    </div>
                                                                  )}
                                                                </Form.Group>
                                                              </Col>
                                  {/* <Col md={4}>
                          <Form.Group>
                            <Form.Label>City</Form.Label>
                            <Form.Select
                              name="city"
                              value={values.city}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={touched.city && errors.city}
                              className={`form-input ${
                                values.city === "" ? "placeholder-style" : ""
                              }`}
                              style={{
                                height: "40px",
                                backgroundColor: "white",
                                border:
                                  touched.city && errors.city
                                    ? "1px solid #dc3545"
                                    : "1px solid #E9ECEF",
                              }}
                            >
                              <option value="">Select City</option>
                              {cities.map((city) => (
                                <option key={city.city_id} value={city.city_id}>
                                  {city.name}
                                </option>
                              ))}
                            </Form.Select>
                            {touched.city && errors.city && (
                              <div className="invalid-feedback d-block">
                                {errors.city}
                              </div>
                            )}
                          </Form.Group>
                        </Col> */}
                                  <Col md={4}>
                                    <Form.Group>
                                      <Form.Label>
                                        Longitude and Latitude
                                      </Form.Label>
                                      <Row className="g-2">
                                        <Col>
                                          <Form.Control
                                            type="text"
                                            name="lat"
                                            placeholder="Latitude"
                                            value={values.lat}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            disabled={!editable}
                                            isInvalid={
                                              touched.lat && errors.lat
                                            }
                                            className="form-input"
                                            style={{
                                              fontSize: "14px",
                                              height: "40px",
                                            }}
                                          />
                                          {touched.lat && errors.lat && (
                                            <div className="invalid-feedback d-block">
                                              {errors.lat}
                                            </div>
                                          )}
                                        </Col>
                                        <Col>
                                          <Form.Control
                                            type="text"
                                            name="lng"
                                            placeholder="Longitude"
                                            value={values.lng}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            disabled={!editable}
                                            isInvalid={
                                              touched.lng && errors.lng
                                            }
                                            className="form-input"
                                            style={{
                                              fontSize: "14px",
                                              height: "40px",
                                            }}
                                          />
                                          {touched.lng && errors.lng && (
                                            <div className="invalid-feedback d-block">
                                              {errors.lng}
                                            </div>
                                          )}
                                        </Col>
                                      </Row>
                                    </Form.Group>
                                  </Col>
                                </Row>
                                </>
                                )}
                                
                                   {/* <div
                                                              className="border rounded"
                                                              style={{ marginTop: "10px" }}
                                                            >
                                                              <div className="d-flex justify-content-between align-items-center fw-semibold px-3 py-2 bg-light border-bottom">
                                                                <div className="d-flex align-items-center gap-3">
                                                                  <span>{isClinicService ? "Specialization" : "Service"}</span>
                                
                                                                 
                                                                </div>
                                
                                                                <span>Price ({currency})</span>
                                                              </div>
                                
                                                              {priceSection?.map((data, idx) => {
                                                                const isLabelField =
                                                                  data?.name?.toLowerCase().includes("tax") ||
                                                                  data?.name?.toLowerCase().includes("total");
                                 data?.name?.toLowerCase().includes("discount");
                                                                return (
                                                                  <div
                                                                    key={data.id || data.name}
                                                                    className={`d-flex justify-content-between align-items-center px-3 py-2 border-bottom ${
                                                                      isLabelField ? "bg-light fw-semibold" : ""
                                                                    }`}
                                                                  >
                                                                    <span>{data?.name}</span>
  <span className="text-muted">
                                                                        {currency} {data?.amount}
                                                                      </span>
                                                                    
                                                                  </div>
                                                                );
                                                              })}
                                                            </div> */}
      </>
    );
    const blockPrice = (
      <>
                                                            {priceSection?.length > 0 && (
  <div
    className="border rounded"
    style={{ marginTop: "10px" }}
  >
    {/* Header */}
    <div className="d-flex justify-content-between align-items-center fw-semibold px-3 py-2 bg-light border-bottom">
      <span>{isClinicService ? "Specialization" : "Service"}</span>
      <span>Price ({currency})</span>
    </div>

    {/* Rows */}
    {priceSection.map((data) => {
      const isLabelField =
        data?.name?.toLowerCase().includes("discount") ||
        data?.name?.toLowerCase().includes("tax") ||
        data?.name?.toLowerCase().includes("total");

      return (
        <div
          key={data.id || data.name}
          className={`d-flex justify-content-between align-items-center px-3 py-2 border-bottom ${
            isLabelField ? "bg-light fw-semibold" : ""
          }`}
        >
          <span>{data.name}</span>
          <span>
            {currency} {data.amount}
          </span>
        </div>
      );
    })}
  </div>
)}
      </>
    );

    const serviceHeading = isClinicService ? "Specialization Information" : isSportsService ? "Sports Information" : "Service Information";
    const detailsHeading = isClinicService ? "Patient Information" : isSportsService ? "Player Information" : "Customer Information";

    // ── original single-page layout (?legacy=1) ─────────────────────────────
    if (legacyLayout) {
      return (
        <Form onSubmit={handleSubmit}>
          <div className="mt-4 mb-2">
            <Accordion activeKey={activeAccordion} alwaysOpen>
              <Accordion.Item eventKey="0">
                <Accordion.Header onClick={() => handleToggleAccordion("0")}>{serviceHeading}</Accordion.Header>
                <Accordion.Body>
                  {blockService}
                  {blockSchedule}
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header onClick={() => handleToggleAccordion("1")}>{detailsHeading}</Accordion.Header>
                <Accordion.Body>
                  {blockPersonal}
                  <div className="mb-4">
                    {blockAddress}
                    {blockPrice}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>

                      <div className="d-flex justify-content-center mb-3 gap-3">
                        <button
                          type="button"
                          onClick={() => setSelectedPaymentMethod("cash")}
                          className={`btn ${selectedPaymentMethod === "cash" ? "btn-danger" : "btn-outline-secondary"}`}
                          style={{ minWidth: "140px" }}
                        >
                           Cash
                        </button>
                        <button
                          type="button"
                          onClick={() => setSelectedPaymentMethod("online")}
                          className={`btn ${selectedPaymentMethod === "online" ? "btn-danger" : "btn-outline-secondary"}`}
                          style={{ minWidth: "140px" }}
                        >
                          Pay Online
                        </button>
                      </div>

                      <div className="d-flex justify-content-center mb-0 gap-4">
                        {/* <Button
                variant="light"
                // onClick={handleNavigation}
                className="custom-btn btn-large"
              >
                Cancel
              </Button> */}
                        <Button
                          type="submit"
                          variant="danger"
                          disabled={isSubmitting || paymentLoading}
                          className="custom-btn btn-large"
                        >
                          {paymentLoading ? <Spinner animation="border" size="sm" /> : "Submit"}
                        </Button>
                      </div>
        </Form>
      );
    }

    // ── guided stepper ──────────────────────────────────────────────────────
    const steps = [
      { key: "service", label: serviceHeading, hint: "What you need" },
      { key: "schedule", label: "Date & Time", hint: "When" },
      { key: "details", label: detailsHeading, hint: "About you" },
      { key: "review", label: "Review & Pay", hint: "Price and payment" },
    ];
    // Formik fields each step owns (the final submit re-checks every one of them).
    const STEP_FIELDS = {
      service: ["partner"],
      schedule: [],
      details: ["userName", "mobileNumber", "email", "gender", "house_no", "area", "location", "state", "country", "landmark", "lat", "lng"],
    };
    const stepKey = steps[stepIndex]?.key;
    const isLast = stepIndex === steps.length - 1;

    const focusField = (name) => {
      setTimeout(() => {
        const el = document.querySelector(`[name="${name}"]`);
        if (el) {
          el.scrollIntoView?.({ behavior: "smooth", block: "center" });
          el.focus?.({ preventScroll: true });
        }
      }, 60);
    };

    // The same checks handleSubmit makes, asked when leaving the step that owns them.
    const checkStep = async (key) => {
      if (key === "service") {
        if (!services || services.length === 0) {
          toast.error(`Please add ${serviceTypeLabel} and Offerings from Admin Setup before ${isClinicService ? "booking an appointment" : "booking"}.`);
          return false;
        }
        if (!serviceTypes || serviceTypes.length === 0) {
          toast.error("Please configure Service Offerings before proceeding.");
          return false;
        }
        if (serviceData?.filter((ele) => ele?.added).length === 0) {
          toast.error("Select Service Offerings to proceed");
          return false;
        }
      }
      if (key === "schedule") {
        if (!timeSelect) {
          setScheduleError("Select a time to continue");
          toast.error("Select Time");
          return false;
        }
        if (isClinicService && (!selectedDoctorId || providerSelected.length === 0)) {
          toast.error("Select Doctor");
          return false;
        }
      }
      const fields = STEP_FIELDS[key] || [];
      if (fields.length) {
        const errs = await validateForm();
        const bad = fields.filter((f) => errs[f]);
        if (bad.length) {
          setTouched({ ...touched, ...Object.fromEntries(bad.map((f) => [f, true])) }, false);
          focusField(bad[0]);
          return false;
        }
      }
      return true;
    };

    const markStep = (key, ok) => {
      setCompletedSteps((prev) => (ok ? (prev.includes(key) ? prev : [...prev, key]) : prev.filter((k) => k !== key)));
      setInvalidSteps((prev) => (ok ? prev.filter((k) => k !== key) : prev.includes(key) ? prev : [...prev, key]));
    };
    const goToStep = (i) => {
      setStepIndex(i);
      window.scrollTo?.({ top: 0, behavior: "smooth" });
    };
    const goNext = async () => {
      const ok = await checkStep(stepKey);
      markStep(stepKey, ok);
      if (ok && !isLast) goToStep(stepIndex + 1);
    };
    const goBack = () => stepIndex > 0 && goToStep(stepIndex - 1);
    // Skipping ahead can never get around a rule: every earlier step is checked again here.
    const submitAll = async () => {
      for (let i = 0; i < steps.length - 1; i += 1) {
        const ok = await checkStep(steps[i].key);
        markStep(steps[i].key, ok);
        if (!ok) {
          goToStep(i);
          return;
        }
      }
      submitForm();
    };
    const onFormSubmit = (e) => {
      e.preventDefault();
      if (isLast) submitAll();
      else goNext();
    };

    const subscriptionHint = userFlexiSubs.length > 0 && !selectedSubscription && (
      <div className="bstep-empty mb-3" style={{ textAlign: "left" }}>
        You have a subscription available.{" "}
        <button type="button" className="btn btn-link p-0 align-baseline" onClick={() => goToStep(0)}>
          Apply it in the {serviceHeading} step
        </button>
      </div>
    );

    const panes = {
      service: (
        <div className="bstep-card">
          <div className="bstep-card-head">
            <h5>{serviceHeading}</h5>
          </div>
          {blockService}
        </div>
      ),
      schedule: (
        <div className="bstep-card">
          <div className="bstep-card-head">
            <h5>Date &amp; Time</h5>
          </div>
          {blockSchedule}
        </div>
      ),
      details: (
        <div className="bstep-card">
          <div className="bstep-card-head">
            <h5>{detailsHeading}</h5>
          </div>
          {blockPersonal}
          <div className="mb-2">{blockAddress}</div>
        </div>
      ),
      review: (
        <>
          <div className="bstep-card">
            <div className="bstep-card-head">
              <h5>Review &amp; Pay</h5>
            </div>
            {subscriptionHint}
            {blockPrice}
            <div className="bstep-divider" />
            <div className="pbk-section-title">Payment method</div>
            <div className="pbk-pay" role="radiogroup" aria-label="Payment method">
              <button
                type="button"
                role="radio"
                aria-checked={selectedPaymentMethod === "cash"}
                className={`pbk-pay-option ${selectedPaymentMethod === "cash" ? "is-on" : ""}`}
                onClick={() => setSelectedPaymentMethod("cash")}
              >
                <strong>Cash</strong>
                <span>Confirm with a code sent to your phone</span>
              </button>
              <button
                type="button"
                role="radio"
                aria-checked={selectedPaymentMethod === "online"}
                className={`pbk-pay-option ${selectedPaymentMethod === "online" ? "is-on" : ""}`}
                onClick={() => setSelectedPaymentMethod("online")}
              >
                <strong>Pay Online</strong>
                <span>Pay now through the secure gateway</span>
              </button>
            </div>
          </div>
          {showOtpPopup && (
            <PublicOtpPanel
              otp={otp}
              onChange={setOtp}
              errorMessage={errorMessages}
              onVerify={verifyOtp}
              onCancel={() => setShowOtpPopup(false)}
              loading={loader}
              phone={values.mobileNumber}
            />
          )}
        </>
      ),
    };

    const summary = {
      currency,
      serviceLabel: isClinicService ? "Specialization" : "Service",
      // priceSection holds one row per chosen offering, then Tax / Discount / Total.
      services: (priceSection || [])
        .filter((r) => r.service_offering_id !== undefined)
        .map((r) => ({ key: r.service_offering_id, name: r.service_offering_name, amount: r.amount })),
      rows: (priceSection || []).filter((r) => r.service_offering_id === undefined),
      when: dateSelect ? [formatDateDisplay(dateSelect), timeSelect ? convertTo12Hour(timeSelect) : ""].filter(Boolean).join(" · ") : "",
      doctorLabel: "Doctor",
      doctor: isClinicService ? clinicDoctors.find((d) => Number(d.id) === Number(selectedDoctorId))?.name || "" : "",
      customerLabel: isClinicService ? "Patient" : isSportsService ? "Player" : "Customer",
      customer: { name: values.userName, phone: values.mobileNumber },
    };

    const vendorName = vendorDetails?.first_name ? vendorDetails?.first_name : vendorDetails?.fullName;
    const locationLine = [vendorDetails?.city_name, vendorDetails?.vendor_state || vendorDetails?.State, vendorDetails?.vendor_country || vendorDetails?.Country]
      .filter(Boolean)
      .join(", ");
    const contactLine = [vendorDetails?.fullName, vendorDetails?.phone_number].filter(Boolean).join(", ");
    const contact =
      locationLine || contactLine || vendorDetails?.email ? (
        <div className="pbk-contact">
          {locationLine && (
            <span className="pbk-contact-item">
              <FaGlobe /> {locationLine}
            </span>
          )}
          {contactLine && (
            <span className="pbk-contact-item">
              <FaPhoneAlt /> {contactLine}
            </span>
          )}
          {vendorDetails?.email && (
            <span className="pbk-contact-item">
              <FaEnvelope /> {vendorDetails.email}
            </span>
          )}
        </div>
      ) : null;

    return (
      <Form noValidate onSubmit={onFormSubmit}>
        <div onClick={close}>
          <PublicBookingShell
            title={`${isClinicService ? "Book an Appointment with" : isSportsService ? "Book a Sports Session with" : "Book a Service with"} ${vendorName}`}
            photo={vendorDetails?.profile_image}
            image={vendorDetails?.image}
            steps={steps}
            stepIndex={stepIndex}
            completed={completedSteps}
            invalid={invalidSteps}
            onSelectStep={goToStep}
            panes={panes}
            summary={summary}
            total={priceSection?.length ? getCartTotal() : null}
            currency={currency}
            onBack={goBack}
            onNext={goNext}
            isLast={isLast}
            busy={isSubmitting || paymentLoading}
            submitLabel="Confirm Booking"
            actionsHidden={showOtpPopup}
            verifying={stripeVerifying}
            contact={contact}
            success={
              showOrderConf ? (
                <PublicSuccess
                  title={
                    isClinicService
                      ? group_id
                        ? "Appointment Updated"
                        : "Appointment Confirmation"
                      : group_id
                      ? "Order Updated"
                      : "Order Confirmation"
                  }
                  rows={confirmationRows}
                  onClose={onHideOrderConf}
                />
              ) : null
            }
          />
        </div>
      </Form>
    );
  };

  // What the confirmation (modal on the legacy page, success screen on the stepper) lists.
  // Rows with no value are dropped so empty labels don't show.
  const confirmationRows = [
                { label: isClinicService ? "Appointment ID" : "Order ID", value: modelData?.booking_id },
                { label: isClinicService ? "Specialization" : "Selected Service", value: modelData?.serviceData?.[0]?.service_name },
                !isClinicService && {
                  label: "Selected Subcategory",
                  value: modelData?.serviceData?.[0]?.service_type_name !== "null" ? modelData?.serviceData?.[0]?.service_type_name : "",
                },
                {
                  label: isClinicService ? "Specialization Type" : "Selected Type",
                  value: (isClinicService ? modelData?.serviceData : modelData?.serviceData?.filter((ele) => ele.added))
                    ?.map((ele) => ele?.service_offering_name)
                    .filter(Boolean)
                    .join(", "),
                },
                !isClinicService && { label: "Service Location", value: modelData?.state },
                {
                  label: "Scheduled Date & Time",
                  value: modelData?.date
                    ? `${new Date(modelData.date).toLocaleDateString()}${modelData?.time ? ` @ ${convertTo12Hour(modelData.time)}` : ""}`
                    : "",
                },
                modelData?.lat && modelData?.lng && {
                  label: "Google Map Link",
                  value: (
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={`https://www.google.com/maps/search/?api=1&query=${modelData?.lat},${modelData?.lng}`}
                    >
                      {`https://www.google.com/maps/search/?api=1&query=${modelData?.lat},${modelData?.lng}`}
                    </a>
                  ),
                },
                !isClinicService && {
                  label: "Address",
                  value: [modelData?.house_no, modelData?.area, modelData?.location, modelData?.landmark, modelData?.state]
                    .filter((part) => part && String(part).trim() && part !== "null")
                    .join(", "),
                },
                {
                  label: isClinicService ? "Patient Name" : isSportsService ? "Player Name" : "Customer Name",
                  value: modelData?.userName,
                },
                {
                  label: isClinicService ? "Patient Contact" : isSportsService ? "Player Contact" : "Customer Contact",
                  value: modelData?.mobileNumber ? formatPhoneNumber(modelData.mobileNumber, currency) : "",
                },
  ].filter((row) => row && row.value !== null && row.value !== undefined && String(row.value).trim() !== "");

  // Guided stepper is the default; ?legacy=1 keeps the original accordion page below.
  if (!legacyLayout) {
    return (
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize={true}
      >
        {renderForm}
      </Formik>
    );
  }

  return (
    <>

      <div className="booking-bg">
        <div className="container py-3">
<div className="position-relative d-flex align-items-center mb-4">
  
  <h2 className="fw-bold m-0 text-center w-100">
    {`${isClinicService ? "Book an Appointment with" : isSportsService ? "Book a Sports Session with" : "Book a Service with"} ${
      vendorDetails?.first_name
        ? vendorDetails?.first_name
        : vendorDetails?.fullName
    }`}
  </h2>

  {/* RIGHT: Profile Image */}
  {vendorDetails?.profile_image && (
    <img
      src={vendorDetails.profile_image}
      alt="profile"
      className="position-absolute"
      style={{
        right: "0",
        width: "70px",
        height: "70px",
        borderRadius: "50%",
        objectFit: "cover",
        border: "2px solid #eee",
      }}
    />
  )}

</div>
          <div className="row align-items-start">
            {vendorDetails?.image && (
  <div
    className="col-md-4"
    style={{
      marginBottom: window.innerWidth < 768 ? "30px" : "0px",
    }}
  >
    <div style={{ width: "100%", height: "500px" }}>
      <img
        src={vendorDetails?.image}
        alt="Profile"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "12px",
          marginTop: "20px",
        }}
      />
    </div>
  </div>
)}
            <div className={vendorDetails?.image ? "col-md-8 " : "col-md-12"}>
              <div onClick={close}>
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                  enableReinitialize={true}
                >
                  {renderForm}
                </Formik>
                {/* ── Returning from Stripe redirect: verify payment before showing confirmation ── */}
                {/* {stripeVerifying && (
                  <div className="otp-popup-overlay">
                    <div className="otp-popup-card position-relative" style={{ paddingTop: "20px", minWidth: "320px" }}>
                      <h5 className="text-center mb-1 fw-bold">Completing Payment</h5>
                      <div className="text-center py-3">
                        <Spinner animation="border" variant="danger" size="sm" />
                        <p className="mt-2 text-muted" style={{ fontSize: "13px" }}>Verifying payment, please wait…</p>
                      </div>
                    </div>
                  </div>
                )} */}

                {showOtpPopup && (
                  <>
                    <div className="otp-popup-overlay">
                      <div
      className="otp-popup-card position-relative"
      style={{ paddingTop: "20px" }}
    >
      <span
        onClick={() => setShowOtpPopup(false)}
        style={{
          position: "absolute",
          top: "10px",
          right: "15px",
          fontSize: "18px",
          cursor: "pointer",
          fontWeight: "bold",
        }}
      >
        ✕
      </span>
                        <div className="greyColor">
                          Enter the code we just sent on your phone
                        </div>
                        <div className="d-flex justify-content-center">
                          <OtpInput
                            value={otp}
                            onChange={setOtp}
                            numInputs={6}
                            renderSeparator={<span>&nbsp;&nbsp;</span>}
                            renderInput={renderOtpInput}
                            containerStyle={{
                              width: "70%",
                              height: "100px",
                              alignItems: "center",
                            }}
                            inputStyle={{ width: "40%", height: "50%" }}
                          />
                        </div>
                        {errorMessages && (
                          <div className="label text-danger text-center">
                            {errorMessages}
                          </div>
                        )}
                        <div className="text-center">
                          <button
                            style={{ margin: "0 auto" }}
                            className="btn btn-block primaryBackground text-white"
                            onClick={verifyOtp}
                            disabled={loader || otp.length !== 6}
                          >
                            Verify OTP
                          </button>
                        </div>
                      </div>
                    </div>
                  </>

                  //   <div className="otp-popup-overlay">
                  //     <div className="otp-popup-card">
                  //       <h5>Enter OTP</h5>

                  //       <OTPInput
                  //         value={otp}
                  //         onChange={setOtp}
                  //         numInputs={6}
                  //         renderSeparator={<span>-</span>}
                  //         renderInput={(props) => <input {...props} />}
                  //       />

                  //       <div className="mt-3 d-flex gap-2 justify-content-center">
                  //         <button
                  //           className="btn btn-secondary"
                  //           onClick={() => setShowOtpPopup(false)}
                  //         >
                  //           Cancel
                  //         </button>

                  //         <button
                  //           className="btn btn-danger"
                  //           onClick={verifyOtp}
                  //         >
                  //           Verify OTP
                  //         </button>
                  //       </div>
                  //     </div>
                  //   </div>
                )}
              </div>
            </div>

<div className="company-footer mt-4">
  {/* {vendorDetails?.address && (
    <div className="footer-item">
      <span className="footer-icon">
        <FaMapMarkerAlt />
      </span>
      <div>{vendorDetails.address}</div>
    </div>
  )} */}
    {(vendorDetails?.city_name || vendorDetails?.vendor_state || vendorDetails?.State || vendorDetails?.vendor_country || vendorDetails?.Country) && (
    <div className="footer-item">
      <span className="footer-icon">
        <FaGlobe />
      </span>
      <div>
        {[vendorDetails?.city_name,
          vendorDetails?.vendor_state || vendorDetails?.State,
          vendorDetails?.vendor_country || vendorDetails?.Country,
        ]
          .filter(Boolean)
          .join(", ")}
      </div>
    </div>
  )}

{(vendorDetails?.phone_number || vendorDetails?.fullName) && (
  <div className="footer-item">
    <span className="footer-icon">
      <FaPhoneAlt />
    </span>

    <div>
      {[vendorDetails?.fullName, vendorDetails?.phone_number]
        .filter(Boolean)
        .join(", ")}
    </div>
  </div>
)}

  {vendorDetails?.email && (
    <div className="footer-item">
      <span className="footer-icon">
        <FaEnvelope />
      </span>
      <div>{vendorDetails.email}</div>
    </div>
  )}
</div>
     <Modal
  show={showOrderConf}
  onHide={onHideOrderConf}
  centered
  size="xl"
  backdrop="static"
  dialogClassName="custom-appointment-modal addServiceModal"
  contentClassName="rounded-4 border-0"
>
  <h4 className="text-center text-danger p-2 pb-0">
    {isClinicService
      ? group_id
        ? "Appointment Updated"
        : "Appointment Confirmation"
      : group_id
      ? "Order Updated"
      : "Order Confirmation"}
  </h4>

  <hr className="mx-4 my-0" />

  <Modal.Body className="px-4 py-4">
            <div className="d-flex flex-column gap-2">
              {/* Rows with no value are dropped so empty labels don't show. */}
              {confirmationRows
                .map((row) => (
                  <div key={row.label} className="d-flex align-items-start">
                    <div className="label" style={{ width: "180px", flexShrink: 0 }}>
                      {row.label}
                    </div>
                    <div style={{ width: "10px" }}>:</div>
                    <div style={{ flex: 1, wordBreak: "break-word" }}>{row.value}</div>
                  </div>
                ))}
            </div>
          </Modal.Body>

  <div className="d-flex justify-content-center align-items-center mb-2">
    <button
      className="btn btn-danger rounded"
      onClick={onHideOrderConf}
    >
      Close
    </button>
  </div>
</Modal>

          </div>
        </div>
      </div>
    </>
  );
}

export default CustomerBookings;
